import { EnglishDictionary } from './en';

const de: EnglishDictionary = {
  login: {
    title: 'Willkommen',
    email: 'E-Mail',
    password: 'Passwort',
    confirmPassword: 'Passwort bestätigen',
    forgotPassword: 'Passwort vergessen?',
    submit: 'Anmelden',
    noAccount: 'Noch kein Konto?',
    signUp: 'Registrieren',
    intro: 'Anmelden bei Ihrem Konto',
    success: 'Anmeldung erfolgreich',
    error: 'Fehler beim Anmelden',
    missingCredentials: 'Bitte geben Sie eine gültige E-Mail-Adresse und ein Passwort ein.',
    blocked: 'Ihr Konto wurde vorübergehend gesperrt.',
  },
  changePassword: {
    title: 'Passwort ändern',
    intro:
      'Bestätigen Sie bitte Ihre E-Mail-Adresse, und Sie erhalten einen einmaligen Code, um Ihr Passwort zurückzusetzen.',
    email: 'E-Mail',
    login: 'Anmelden',
    oneTimeCode: 'Einmalcode',
    confirmPassword: 'Passwort bestätigen',
    newPassword: 'Neues Passwort',
    minPassword: 'Das Passwort muss mindestens 6 Zeichen lang sein',
    enterOTP: 'Bitte geben Sie den an Ihre E-Mail gesendeten OTP-Code ein.',
    verifyOTP: 'OTP überprüfen',
    sentOTP: 'OTP an Ihre E-Mail gesendet',
    errorSendingOTP:
      'Die E-Mail mit dem Einmalcode konnte nicht gesendet werden. Bitte versuchen Sie es erneut oder wenden Sie sich an den Support.',
    invalidOTP: 'Ungültiger OTP',
    verifiedOTP: 'OTP erfolgreich überprüft',
    passwordChanged: 'Passwort erfolgreich geändert',
    errorChangingPassword: 'Fehler beim Ändern des Passworts',
    buttonText: 'Passwort ändern',
    errorNoUser: 'Mit der E-Mail-Adresse {email} ist kein Benutzer verknüpft.',
  },
  logout: {
    success: 'Sie wurden erfolgreich abgemeldet.',
    error: 'Fehler beim Abmelden.',
  },
  resetPassword: {
    title: 'Passwort zurücksetzen',
    email: 'E-Mail',
    submit: 'Link senden',
    backToLogin: 'Zurück zur Anmeldung',
    success: 'E-Mail zum Zurücksetzen gesendet',
    newPassword: 'Neues Passwort',
    confirmPassword: 'Neues Passwort bestätigen',
    changePassword: 'Passwort ändern',
  },
  validation: {
    required: 'Dieses Feld ist erforderlich',
    invalidEmail: 'Ungültige E-Mail-Adresse',
    passwordMismatch: 'Passwörter stimmen nicht überein',
    passwordTooShort: 'Das Passwort muss mindestens 8 Zeichen lang sein',
  },
  fields: {
    fullName: 'Vollständiger Name',
    email: 'E-Mail',
    phone: 'Telefon',
    password: 'Passwort',
    confirmPassword: 'Passwort bestätigen',
    doctor: 'Ärzte',
    indications: 'Pathologien',
    notes: 'Notizen',
    id: 'ID',
    patientId: 'Patienten-ID',
    dateOfBirth: 'Geburtsdatum',
    gender: 'Geschlecht',
    created: 'Hinzugefügt am',
    createdAt: 'Erstellt am',
    updatedAt: 'Aktualisiert am',
    createdBy: 'Erstellt von',
    male: 'Männlich',
    female: 'Weiblich',
    other: 'Andere',
    fileSize: 'Dateigröße',
    revisionHistory: 'Revisionsverlauf',
    exportStatus: 'Exportstatus',
  },
  patientsPage: {
    title: 'Patienten',
    description: 'Verwalten Sie Ihre Patienten',
    newPatient: 'Neuer Patient',
    instructions: `##### **Wen fügen Sie hinzu?**
Füllen Sie die Felder aus, um ein Patientenprofil zu erstellen.
##### **Tipps:**
- kennzeichnet ein Pflichtfeld
- Das Ausfüllen des optionalen Feldes kann später nützlich sein
- Alle Patientendaten werden anonym gespeichert`,
  },
  addPatientPage: {
    title: 'Patient Hinzufügen',
    description: 'Fügen Sie einen neuen Patienten zum System hinzu',
    success: 'Patient erfolgreich hinzugefügt',
    error: 'Fehler beim Hinzufügen des Patienten',
    submitText: 'Patient Hinzufügen',
  },
  sections: {
    generalPatientInformation: 'Allgemeine Patienteninformationen',
    medicalInformation: 'Medizinische Informationen',
    orderInformation: 'Bestellinformationen',
  },
  placeholders: {
    fullName: 'Vollständigen Namen eingeben',
    email: 'E-Mail-Adresse eingeben',
    phone: 'Telefonnummer eingeben',
    doctor: 'Ärzteinformationen eingeben',
    indications: 'Pathologie-Informationen eingeben',
    notes: 'Notizen eingeben',
    patientId: 'Patienten-ID eingeben',
    dateOfBirth: 'Geburtsdatum eingeben',
    gender: 'Geschlecht eingeben',
    password: 'Passwort eingeben',
    confirmPassword: 'Bestätigen Sie Ihr Passwort',
    companyName: 'Firmennamen eingeben',
    clientId: 'Kunden-ID eingeben',
    line1: 'Adresszeile 1 eingeben',
    city: 'Stadt eingeben',
    postalCode: 'Postleitzahl eingeben',
    country: 'Land eingeben',
    state: 'Bundesland eingeben',
  },
  onUpdate: {
    title: 'Patient Aktualisieren',
    success: 'Patient erfolgreich aktualisiert',
    error: 'Fehler beim Aktualisieren des Patienten',
  },
  onUpdateOrder: {
    title: 'Bestellung aktualisieren',
    success: 'Bestellung erfolgreich aktualisiert',
    error: 'Fehler beim Aktualisieren der Bestellung',
  },
  onDelete: {
    title: 'Patient Löschen',
    message:
      'Sind Sie sicher, dass Sie diesen Patienten löschen möchten? Alle 3D-Scans, E-Limbs und unfertige Produkte, die mit diesem Patienten verknüpft sind, werden gelöscht. Bestellte Produkte bleiben auf der Bestellseite erhalten, können aber nicht geändert werden.',
    confirmText: 'Löschen',
    success: 'Patient erfolgreich gelöscht',
    error: 'Fehler beim Löschen des Patienten',
    elimb: {
      title: 'E-limb löschen',
      message: 'Sind Sie sicher, dass Sie diesen E-limb löschen möchten?',
      success: 'E-limb erfolgreich gelöscht',
      error: 'Fehler beim Löschen des E-limb',
    },
    scan: {
      title: 'Scan löschen',
      message: 'Sind Sie sicher, dass Sie diesen Scan löschen möchten?',
      success: 'Scan',
      error: 'Fehler beim Löschen des Scans',
    },
  },
  onDeleteUser: {
    title: 'Benutzer Löschen',
    message:
      'Sind Sie sicher, dass Sie diesen Benutzer löschen möchten? Alle Patienten, bestellte Produkte, 3D-Scans und E-Limbs, die mit diesem Benutzer verknüpft sind, werden an einen anderen Benutzer übertragen.',
    transferTo: 'Bitte geben Sie an, an wen die Daten übertragen werden sollen:',
    confirmText: 'Löschen',
    success: 'Benutzer erfolgreich gelöscht',
    error: 'Fehler beim Löschen des Benutzers',
    selectUserToTransfer: 'Benutzer auswählen, an den die Daten übertragen werden sollen',
    noUserToTransfer: 'Kein Benutzer zum Übertragen ausgewählt',
    lastAdmin:
      'Es muss immer mindestens einen Administrator geben. Um dies zu ändern, wenden Sie sich bitte an OTB.',
    forbidden: 'Sie haben keine Berechtigung, dieses Konto zu löschen.',
    referenced:
      'Dieses Konto ist noch mit anderen Datensätzen verknüpft und konnte nicht gelöscht werden. Es wurde nichts geändert — bitte wenden Sie sich an OTB.',
    invalidTransfer:
      'Die Daten können nur auf ein anderes aktives Konto desselben Unternehmens übertragen werden. Es wurde nichts geändert — bitte wählen Sie einen anderen Benutzer.',
  },
  onCreatePatient: {
    existingPatientName: {
      title: 'Bestehender Patient',
      message:
        'Sie haben einen Patienten mit dem gleichen Namen wie ein bereits bestehender Patient erstellt: {fullName}.\nMöchten Sie diesen als neuen Patienten speichern oder den bestehenden Patienten bearbeiten?',
      confirmText: 'Als neuen Patienten speichern',
      cancelText: 'Bestehenden Patienten bearbeiten',
    },
    existingPatientId: {
      title: 'Bestehender Patient',
      message:
        'Sie haben einen Patienten mit der gleichen ID wie ein bereits bestehender Patient erstellt: {fullName}.\nMöchten Sie den bestehenden Patienten bearbeiten oder die Erstellung des neuen Patienten abbrechen?',
      confirmText: 'Bestehenden Patienten bearbeiten',
      cancelText: 'Patientenerstellung abbrechen',
      cancelMessage: 'Patientenerstellung abgebrochen',
    },
  },
  onEditPatient: {
    existingPatientName: {
      title: 'Vorhandener Patient',
      message:
        'Sie haben einen Patienten mit demselben Namen wie ein bereits vorhandener Patient aktualisiert: {fullName}.\nSollen die Änderungen auf den aktuellen Patienten angewendet werden?',
      confirmText: 'Änderungen anwenden',
      cancelText: 'Patientenaktualisierung abbrechen',
    },
  },
  actions: {
    edit: 'Bearbeiten',
    delete: 'Löschen',
    view: 'Patient anzeigen',
    add: 'Patient hinzufügen',
    save: 'Speichern',
    cancel: 'Abbrechen',
    continue: 'Fortfahren',
    reorder: 'Neu bestellen',
    duplicate: 'Duplizieren',
    duplicateConfig: 'Konfiguration duplizieren und aktualisieren',
    addToCart: 'Zum Warenkorb hinzufügen',
    removeFromCart: 'Aus dem Warenkorb entfernen',
    upload: 'Hochladen',
    review: 'Produkt bewerten',
  },
  messages: {
    created: 'Patient erstellt',
    updated: 'Patient aktualisiert',
    deleted: 'Patient gelöscht',
    createError: 'Fehler beim Erstellen des Patienten',
    updateError: 'Fehler beim Aktualisieren des Patienten',
    deleteError: 'Fehler beim Löschen des Patienten',
  },
  confirmations: {
    update: {
      title: 'Aktualisieren',
      message: 'Sind Sie sicher, dass Sie diesen Eintrag aktualisieren möchten?',
      confirmText: 'Aktualisieren',
    },
    delete: {
      title: 'Löschen',
      message: 'Sind Sie sicher, dass Sie diesen Eintrag löschen möchten?',
      confirmText: 'Löschen',
    },
    create: {
      confirmText: 'Erstellen',
    },
  },
  overviewPage: {
    title: 'Patientenübersicht',
    description: 'Patientendetails anzeigen und verwalten',
    newProduct: 'Neues Produkt',
    noProducts: 'Keine Produkte verfügbar',
    productId: 'Produkt-ID',
    productType: 'Produkttyp',
    createdOn: 'Erstellt am',
    status: 'Status',
    newScan: 'Neuer Scan',
    noScans: 'Keine Scans verfügbar',
    scanId: 'Scan-ID',
    scanName: 'Scanname',
    scannedLimb: 'Gescannte Gliedmaße',
    newElimb: 'Neue E-Gliedmaße',
    noElimbs: 'Keine E-Gliedmaßen verfügbar',
    elimbId: 'E-Gliedmaßen-ID',
    elimbType: 'E-Gliedmaßen-Typ',
    editNotes: 'Notizen Bearbeiten',
    notesUpdated: 'Notizen erfolgreich aktualisiert',
    notesUpdateError: 'Fehler beim Aktualisieren der Notizen',
    scans: 'Scans',
    elimbs: 'E-Gliedmaßen',
    products: 'Produkte',
  },
  admin: {
    title: 'Administrationsbereich',
  },
  users: {
    title: 'Benutzer',
    add: 'Benutzer hinzufügen',
    edit: 'Benutzer bearbeiten',
    delete: 'Benutzer löschen',
    sections: {
      generalInfo: 'Allgemeine Informationen',
      loginInfo: 'Login-Informationen',
      roles: 'Rollen',
      passwordPicker: {
        title: 'Wer muss das Passwort festlegen?',
        true: 'Du',
        false: 'Der Benutzer',
      },
      warning: {
        alert: 'Dieser Benutzer hat noch kein Passwort festgelegt.',
        button: 'Neue E-Mail senden',
      },
      platformAccess: {
        title: 'Zugang zur Plattform',
        field: 'Gesperrt',
      },
    },
    roles: {
      professional: 'Fachkraft',
      admin: 'Administrator',
      distributor: 'Distributor',
      master: 'Master',
    },
    fields: {
      id: 'ID',
      fullName: 'Vollständiger Name',
      email: 'E-Mail',
      phone: 'Telefon',
      createdAt: 'Erstellt am',
      orderedProducts: 'Bestellte Produkte',
      unfinishedProducts: 'Unfertige Produkte',
      roles: 'Rollen',
    },
    instructions: `##### **Was zu tun ist?**
Füllen Sie die (erforderlichen) Felder aus, um ein neues Unternehmen/Distributor zu erstellen und einen Benutzer dem Unternehmen zuzuweisen.
##### **Tipps:**
- Die erforderlichen Felder sind mit einem * gekennzeichnet
- Wenn Sie keine Patienten-ID ausfüllen, generiert die Software automatisch eine. Sie können dies später ändern`,
  },
  companies: {
    title: 'Unternehmen',
    add: 'Unternehmen hinzufügen',
    edit: 'Unternehmen bearbeiten',
    delete: 'Unternehmen löschen',
    new: 'Neues Unternehmen',
    description: 'Neues Unternehmen erstellen',
    filterByDistributor: 'Nach Distributor filtern',
    addDistributor: 'Distributor hinzufügen',
    sections: {
      generalInfo: 'Allgemeine Unternehmensinformationen',
      settings: 'Einstellungen',
      address: 'Adresse',
      users: 'Benutzer',
      companyOverview: 'Unternehmensübersicht',
      productWorkflows: 'Produkt-Workflows',
      supportTickets: 'Support-Tickets',
      orderedProducts: 'Bestellte Produkte',
      advancedSettings: 'Erweiterte Einstellungen',
      productWorkflowStepConfigurationCard: {
        title: 'Schritte der {material}-Produkt-Workflows ein-/ausblenden',
      },
    },
    fields: {
      name: 'Unternehmensname',
      clientId: 'Kunden-ID (mindestens 4 Zeichen)',
      clientIdHeader: 'Kunden-ID',
      generalEmail: 'Allgemeine E-Mail-Adresse',
      generalPhone: 'Allgemeine Telefonnummer',
      fullName: 'Vollständiger Name',
      deletedUser: 'Gelöschter Benutzer',
      email: 'E-Mail',
      phone: 'Telefon',
      line1: 'Adress',
      city: 'Stadt & Postleitzahl',
      state: 'Bundesland',
      postalCode: 'Postleitzahl',
      country: 'Land',
      createdBy: 'Erstellt von',
      dateCreated: 'Erstellungsdatum',
      openSupportTickets: 'Offene Support-Tickets',
      orderedProducts: 'Bestellte Produkte',
      users: 'Benutzer',
      id: 'ID',
      unfinishedProducts: 'Unfertige Produkte',
    },
    settings: {
      useOwnPatientId: {
        label: 'Eigene Patienten-ID verwenden',
        description:
          'Durch Aktivieren dieser Option können Sie Ihre eigene Patienten-ID definieren, die dann ein Pflichtfeld wird. Wenn Sie diese Option deaktivieren, generiert die Plattform die Patienten-IDs zufällig.',
      },
      sharePatients: {
        label: 'Patienten zwischen Benutzern teilen',
        description:
          'Durch Aktivieren dieser Option können alle Benutzer dieser Organisation alle Patienten sehen, bearbeiten und Produkte für sie erstellen. Wenn Sie diese Option deaktivieren, kann nur der Benutzer, der einen Patienten erstellt, diesen sehen, bearbeiten oder ein Produkt für ihn erstellen.',
      },
      useShippingInformation: {
        label: 'Versandinformationen für Tochterunternehmen verwenden',
        description:
          'Durch Aktivieren dieser Option werden alle von diesem Unternehmen erstellten Bestellungen an diesen Distributor gesendet und mit ihm verknüpft. (Nicht vom Unternehmensadministrator bearbeitbar)',
      },
      adminOrderFollowUp: {
        label:
          'Der Administrator wird in die Nachverfolgung von Unternehmensbestellungen einbezogen.',
        description:
          'Wenn Sie dieses Kästchen ankreuzen, erhalten die Administratoren eine E-Mail, wenn ein Produkt bestellt wird.',
      },
      orderReferenceFollowUp: {
        label: 'Bestellnummer-Erinnerungen.',
        description:
          'Wenn Sie dieses Kästchen ankreuzen, erhalten Sie täglich eine Erinnerung, Ihre Bestellnummer einzugeben, falls diese noch nicht eingegeben wurde.',
      },
      credits: {
        title: 'Credits',
      },
      onlyAdminsCanBuyCredits: {
        label: 'Nur Administratoren dürfen Credits kaufen',
        description:
          'Wenn Sie dieses Kästchen aktivieren, können Fachkräfte Credits nur anfordern und die Administratoren kaufen sie.',
      },
      pricePerCredit: {
        label: 'Preis pro Credit (EUR)',
        description:
          'Was ein Credit diese Organisation in Euro kostet. Belassen Sie 0, um den Preis des Distributors oder sonst von Orthobroker zu übernehmen.',
      },
      creditPriceCarpi: {
        label: 'Carpi (Credits)',
        description:
          'Credits, nicht Euro, für eine Carpi-STL. Null übernimmt den Wert des Distributors oder sonst von Orthobroker.',
      },
      creditPriceMino: {
        label: 'Mino (Credits)',
        description:
          'Credits, nicht Euro, für eine Mino-STL. Null übernimmt den Wert des Distributors oder sonst von Orthobroker.',
      },
      creditPriceVolar: {
        label: 'Volar (Credits)',
        description:
          'Credits, nicht Euro, für eine Volar-STL. Null übernimmt den Wert des Distributors oder sonst von Orthobroker.',
      },
      creditPacks: {
        title: 'Credit-Paket {pack}',
        visible: {
          label: 'Paket anzeigen',
          description: 'Auf der Credits-Seite dieses Unternehmens anbieten.',
        },
        credits: 'Credits',
        discount: 'Rabatt (%)',
      },
      notifications: {
        success: 'Unternehmenseinstellungen aktualisiert.',
        error: 'Bei der Aktualisierung der Unternehmenseinstellungen ist ein Fehler aufgetreten.',
      },
    },
    whitelabel: {
      title: 'Whitelabel',
      logo: {
        label: 'Unternehmenslogo',
        description:
          'Ersetzt das OrthoSolid-Logo für die Nutzer dieses Unternehmens. PNG, JPG oder WebP, bis zu 2 MB.',
        upload: 'Bild auswählen',
        remove: 'Logo entfernen',
        removeTitle: 'Unternehmenslogo entfernen',
        removeMessage:
          'Das Logo dieses Unternehmens entfernen? Seine Nutzer sehen dann wieder das OrthoSolid-Logo.',
        empty: 'Kein Unternehmenslogo – die Nutzer sehen das OrthoSolid-Logo.',
      },
      notifications: {
        success: 'Unternehmenslogo aktualisiert.',
        removed: 'Unternehmenslogo entfernt.',
        error: 'Bei der Aktualisierung des Unternehmenslogos ist ein Fehler aufgetreten.',
        notAllowed: 'Nur Master-Benutzer können das Unternehmenslogo ändern.',
        noFile: 'Wählen Sie zuerst ein Bild aus.',
        invalidType: 'Diese Datei ist kein unterstütztes Bild. Verwenden Sie PNG, JPG oder WebP.',
        tooLarge: 'Dieses Bild ist zu groß. Die maximale Größe beträgt 2 MB.',
      },
    },
    actions: {
      create: {
        errorPrefix: 'Fehler beim Anlegen des Unternehmens:',
      },
      delete: {
        button: 'Unternehmen löschen',
        title: 'Unternehmen löschen',
        message: 'Sind Sie sicher, dass Sie dieses Unternehmen löschen möchten?',
        success: 'Das Unternehmen wurde erfolgreich gelöscht',
        error: 'Beim Löschen des Unternehmens ist ein Fehler aufgetreten',
      },
      edit: {
        success: 'Das Unternehmen wurde erfolgreich aktualisiert.',
        errorPrefix: 'Fehler beim Aktualisieren des Unternehmens:',
      },
      companyID: 'Die Unternehmens-ID ist erforderlich.',
      error:
        'Die Kunden-ID darf nur Buchstaben, Zahlen, Punkte, Bindestriche und Unterstriche enthalten.',
      saveDecisionFlowOptions: {
        success: 'Die Optionen, die dieses Unternehmen in {flow} wählen darf, wurden gespeichert.',
        notAllowed:
          'Sie können nur die Optionen von Unternehmen festlegen, die Sie registriert haben, und nur im Rahmen Ihrer eigenen Optionen.',
        error:
          'Die Optionen für {flow} konnten nicht gespeichert werden. Laden Sie die Seite neu und versuchen Sie es erneut.',
      },
      toggleProductWorkflowStepConfigurations: {
        field: '{material}-Produkt-Workflow-Schritte umschalten',
        productionLocation: {
          title: 'Produktionsstandort',
        },
        material: {
          title: 'Material',
        },
        thumbSupport: {
          title: 'Daumenstütze',
        },
        braceLength: {
          title: 'Länge der Schiene',
        },
        openingLocation: {
          title: 'Eröffnungsort',
        },
        hinges: {
          title: 'Scharniere',
        },
        hingedOption: {
          title: 'Klappbare Variante',
        },
        padding: {
          title: 'Polsterung',
        },
        extraPadding: {
          title: 'Zusätzliche Polsterung',
        },
        straps: {
          title: 'Gurte',
        },
      },
      duplicateConfig: {
        title: 'Produkt in eine neue Konfiguration duplizieren',
        noOutcome:
          'Zu diesen Antworten passt keine Konfiguration. Ändern Sie eine Antwort, oder bitten Sie einen Administrator, den Entscheidungsablauf zu vervollständigen.',
      },
    },
    instructions: `##### **Was zu tun ist?**
Füllen Sie die (erforderlichen) Felder aus, um ein neues Unternehmen/Distributor zu erstellen und einen Benutzer dem Unternehmen zuzuweisen.
##### **Tipps:**
- Die erforderlichen Felder sind mit einem * gekennzeichnet
- Wenn Sie keine Patienten-ID ausfüllen, generiert die Software automatisch eine. Sie können dies später ändern`,
  },
  roles: {
    title: 'Rollen',
    admin: 'Admin',
    distributor: 'Distributor',
    master: 'Master',
    user: 'Benutzer',
  },
  status: {
    pending: 'Bestellung Ausstehend',
    inProgress: 'Bestellung In Bearbeitung',
    completed: 'Bestellung Abgeschlossen',
    cancelled: 'Bestellung Storniert',
  },
  orders: {
    title: 'Bestellungen',
    new: 'Neue Bestellung',
    details: 'Bestelldetails',
    status: 'Status',
    date: 'Bestelldatum',
    id: 'Bestellnummer',
    placeOrder: 'Bestellung aufgeben',
    sections: {
      generalInfo: 'Allgemeine Informationen',
      shippingInfo: 'Versandinformationen',
    },
    fields: {
      status: 'Status',
      reference: 'Referenz',
      clientId: 'Kunden-ID',
      id: 'ID',
      created: 'Erstellt',
      totalItems: 'Gesamtanzahl Artikel',
      notes: 'Notizen',
      companyName: 'Betriebsname',
      material: 'Material',
    },
    email: {
      received:
        'Wir freuen uns, Ihnen mitteilen zu können, dass wir Ihre Bestellung erhalten haben und sie in Kürze bearbeiten werden. Nachstehend finden Sie die Details Ihrer Bestellung:',
      beingPrepared:
        'Ihre Bestellung wird vorbereitet und wir werden Sie benachrichtigen, sobald sie auf dem Weg ist. Sie können den Fortschritt verfolgen, indem Sie den Bestellstatus auf der Plattform überprüfen. Wenn Sie Fragen haben oder weitere Unterstützung benötigen, können Sie sich gerne an uns wenden: orders@orthosolid.com.',
      signature: 'Mit freundlichen Grüßen\nDas Orthobroker-Team\nhttps://platform.orthosolid.com',
    },
  },
  shipping: {
    title: 'Versandinformationen',
    name: 'Vollständiger Name',
    email: 'E-Mail',
    phone: 'Telefon',
    address: 'Adresse',
    city: 'Stadt',
    postalCode: 'Postleitzahl',
    country: 'Land',
  },
  preview: {
    demo: 'Demo-Vorschau',
    noPreview: 'Keine Vorschau verfügbar',
    noGlbFound: 'Kein GLB gefunden',
    loading: 'Wird geladen...',
  },
  modelPreview: {
    orientationLabel: 'Ausrichtung',
    autoOrientation: 'Automatische Ausrichtung',
    autoOrientationTooltip: 'Automatische Ausrichtung basierend auf Modellabmessungen',
    xAxisUp: 'X-Achse oben',
    xAxisUpTooltip: 'Drehen, um X-Achse vertikal zu machen',
    yAxisUp: 'Y-Achse oben',
    yAxisUpTooltip: 'Standard vertikale Ausrichtung',
    zAxisUp: 'Z-Achse oben',
    zAxisUpTooltip: 'Drehen, um Z-Achse vertikal zu machen',
    error: 'Es gibt noch kein Modell zur Anzeige.',
    unavailableCombination: 'Diese Kombination ist nicht verfügbar.',
  },
  support: {
    title: 'Hilfe anfordern',
    description1:
      'Danke für Ihre Kontaktaufnahme, wir helfen Ihnen gerne bei der Lösung Ihres Problems. Um sicherzustellen, dass wir allen Benutzern die richtige Unterstützung bieten können, möchten wir Sie darauf hinweisen, dass es ein ausführliches Plattform-Handbuch gibt, das Sie bei Problemen lesen können.',
    description2:
      'Wenn Ihr Problem nicht im Handbuch behandelt wird, beschreiben Sie es bitte im Feld unten. Wir werden es innerhalb von 24 Stunden prüfen (während der Arbeitstage). Sie erhalten eine Benachrichtigung, wenn wir Ihr Ticket bearbeitet haben',
    manualButton: 'Plattform-Handbuch',
    issueLabel: 'Beschreiben Sie Ihr Problem',
    issuePlaceholder: 'Bitte beschreiben Sie Ihr Problem hier...',
    createButton: 'Ticket erstellen',
    typeLabel: 'Betrifft',
    typePlaceholder: 'Thema auswählen',
    addTicket: 'Ticket hinzufügen',
    platformManual: 'Plattformhandbuch',
    platformManualDescription:
      'Lesen Sie die Richtlinien oder suchen Sie nach einer Funktionalität',
    academy: 'Akademie',
    academyDescription: 'Werden Sie durch Video-Tutorials zum Experten',
    button: 'Als gelöst markieren',
    notification: {
      resolved: {
        success: 'Als gelöst markiert',
        error:
          'Beim Markieren als gelöst ist ein unerwarteter Fehler aufgetreten. Bitte versuchen Sie es erneut.',
      },
      under_investigation: {
        success: 'Als in Untersuchung befindlich gekennzeichnet',
        error:
          'Beim Markieren als „in Untersuchung“ ist ein unerwarteter Fehler aufgetreten. Bitte versuchen Sie es erneut.',
      },
    },
  },
  buttons: {
    back: 'Zurück',
    cancel: 'Abbrechen',
    save: 'Speichern',
    edit: 'Bearbeiten',
    delete: 'Löschen',
    add: 'Hinzufügen',
    select: 'Auswählen',
    selected: 'Ausgewählt',
    discover: 'Entdecken',
    readMore: 'Weiterlesen',
    continue: 'Fortfahren',
    clear: 'Löschen',
  },
  errors: {
    notFound: {
      title: '404',
      subtitle: 'Seite nicht gefunden',
      description: 'Die gesuchte Seite existiert nicht oder wurde verschoben.',
      action: 'Zurück zur Startseite',
    },
    general: {
      title: 'Etwas ist schief gelaufen!',
      description: 'Es ist ein unerwarteter Fehler aufgetreten. Bitte versuchen Sie es erneut.',
      action: 'Erneut versuchen',
    },
    noAccess: 'Sie haben keinen Zugriff auf diese Seite.',
    duplicate: {
      error: 'Beim Duplizieren des Produkts ist ein Fehler aufgetreten.',
    },
  },
  createUser: {
    errors: {
      alreadyExists:
        'Dieser Benutzer verfügt bereits über ein funktionierendes Konto. Falls das Passwort zurückgesetzt werden muss, wenden Sie sich bitte an Ihren Administrator.',
      passwordLength: 'Das Passwort muss mindestens 6 Zeichen lang sein.',
      error: 'Fehler beim Erstellen der Authentifizierung:',
      noEmail:
        'Beim Abrufen Ihrer E-Mail ist ein Fehler aufgetreten. Bitte wenden Sie sich an den Support.',
      JWTExpired: {
        new: 'Ihre Einladung zur OrthoSolid-Plattform ist abgelaufen. Bitte wenden Sie sich an Ihren Administrator, um eine neue Einladung zu erhalten.',
        reset:
          'Ihre Einladung zum Zurücksetzen Ihres Passworts ist abgelaufen. Bitte wenden Sie sich an Ihren Administrator, um eine neue Einladung zu erhalten.',
      },
    },
    subject: 'Legen Sie Ihr Passwort für OrthoSolid fest.',
    mail: `Lieber {fullName},
    
    Ihr Administrator hat für Sie ein Konto auf der OrthoSolid-Plattform eingerichtet.
    Klicken Sie auf diesen Link, um ein Passwort festzulegen: {passwordURL}

    Mit freundlichen Grüßen,
    das OrthoSolid-Team. 
    `,
    html: `
      <p>Lieber {fullName},</p>
      <p>
        Ihr Administrator hat für Sie ein Konto auf der OrthoSolid-Plattform eingerichtet.
        Klicken Sie auf <a href="{passwordURL}">diesen Link</a>, um ein Passwort festzulegen.
      </p>
      <p>
        Mit freundlichen Grüßen,<br />
        das OrthoSolid-Team.
      </p>
    `,
  },
  onResetPassword: {
    message:
      'Wenn Sie auf „Weiter“ klicken, wird eine E-Mail an den Benutzer gesendet. Dieser wird dann auf eine Seite weitergeleitet, auf der er sein Passwort zurücksetzen kann.',
    success: 'Die E-Mail wurde an den Benutzer gesendet.',
    error: 'Beim Versenden der E-Mail an den Benutzer ist ein Fehler aufgetreten.',
    mail: {
      subject: 'Setzen Sie Ihr Passwort für die Orthosolid-Plattform zurück.',
      text: `Lieber {fullName},
    
    Ihr Administrator hat für Sie eine Passwortzurücksetzung beantragt.
    Rufen Sie diesen Link auf, um Ihr Passwort zurückzusetzen: {passwordURL}

    Mit freundlichen Grüßen,
    das OrthoSolid-Team. 
    `,
      html: `
      <p>Lieber {fullName},</p>
      <p>
        Ihr Administrator hat für Sie eine Passwortzurücksetzung beantragt.
        Rufen Sie <a href="{passwordURL}">diesen Link</a> auf, um Ihr Passwort zurückzusetzen.
      </p>
      <p>
        Mit freundlichen Grüßen,<br />
        das OrthoSolid-Team.
      </p>
    `,
    },
    errorUserWithoutPassword:
      '<p>Für diesen Benutzer wurde ein Konto eingerichtet, es wurde jedoch noch kein Passwort festgelegt. Bitte rufen Sie <a href="{passwordURL}">diesen Link</a> auf, um ein Passwort festzulegen.</p>',
  },
  common: {
    language: 'Sprache',
    loading: 'Laden...',
    noResults: 'Keine Ergebnisse gefunden',
    search: 'Suchen',
    noValue: '-',
    loadingPage: 'Seite wird geladen...',
    loadingData: 'Daten werden geladen...',
    processing: 'Verarbeitung...',
    removeFromCart: 'Aus dem Warenkorb entfernen',
    fields: {
      created: 'Erstellt',
    },
    cancel: 'Abbrechen',
    hiddenData: 'Diese Daten sind ausgeblendet',
  },
  onResendNewPasswordMail: {
    title: 'E-Mail mit neuem Passwort senden',
    message:
      'Wenn Sie auf „Weiter“ klicken, wird eine E-Mail an den Benutzer gesendet. Dieser wird auf eine Seite weitergeleitet, auf der er erneut die Möglichkeit hat, sein Passwort festzulegen.',
  },
  ticketDetails: {
    generalInfo: 'Allgemeine Ticket-Informationen',
    involving: 'Betrifft',
    ticketId: 'Ticket-ID',
    scanId: 'Scan-ID',
    createdOn: 'Erstellt am',
    createdBy: 'Erstellt von',
    lastAdjusted: 'Zuletzt geändert am',
    lastAdjustedBy: 'Geändert von',
    delete: 'Löschen',
    deleteTitle: 'Ticket löschen',
    deleteConfirm: 'Sind Sie sicher, dass Sie dieses Ticket löschen möchten?',
    deleteSuccess: 'Ticket gelöscht',
    deleteError: 'Fehler beim Löschen des Tickets',
    resolveTicket: 'Ticket lösen',
    ticketResolved: 'Ticket gelöst',
  },
  productCatalogue: {
    title: 'Produktkatalog',
    viewAll: 'Alle anzeigen',
  },
  discussion: {
    title: 'Diskussion',
    newMessage: 'Neue Nachricht',
    send: 'Senden',
    reply: 'Antworten',
  },
  form: {
    save: 'Änderungen speichern',
    delete: 'Löschen',
    required: 'Erforderlich',
    enterValue: 'Wert eingeben',
    selectDate: 'Datum auswählen',
    slider: {
      autoAdjust: 'Automatische Berechnung ein-/ausschalten',
    },
  },
  notes: {
    title: 'Notizen',
    edit: 'Notizen bearbeiten',
    placeholder: 'Notizen eingeben',
    updated: 'Notizen aktualisiert',
    updateError: 'Fehler beim Aktualisieren der Notizen',
  },
  referenceNumber: {
    title: 'Referenznummer',
    placeholder: 'Ihre Bestellreferenznummer (falls zutreffend)',
  },
  notifications: {
    success: 'Erfolg',
    error: 'Fehler',
    info: 'Information',
    warning: 'Warnung',
    company: {
      created: 'Firma erfolgreich erstellt',
      deleted: 'Firma erfolgreich gelöscht',
      deleteError: 'Fehler beim Löschen der Firma',
      updated: 'Firma erfolgreich aktualisiert',
      updateError: 'Fehler beim Aktualisieren der Firma',
    },
    order: {
      created: 'Bestellung erfolgreich erstellt',
      createError: 'Fehler beim Erstellen der Bestellung! Bitte kontaktieren Sie den Kundendienst.',
      insufficientCredits:
        'Nicht genügend Credits für diese Bestellung. Laden Sie Ihre Credits auf und versuchen Sie es erneut.',
      creditsMisconfigured:
        'Diese Bestellung konnte nicht in Credits berechnet werden. Bitte wenden Sie sich an OrthoSolid — der Kauf weiterer Credits behebt das nicht.',
    },
    user: {
      created: 'Benutzer erfolgreich erstellt',
      createError: 'Fehler beim Erstellen des Benutzers',
    },
    product: {
      addedToCart: 'Produkt zum Warenkorb hinzugefügt',
      removedFromCart: 'Produkt aus dem Warenkorb entfernt',
      cartError: 'Fehler beim Aktualisieren des Warenkorbs',
      duplicated: 'Das Produkt wurde korrekt dupliziert.',
      duplicatedConfig: 'Das Produkt wurde mit einer neuen Konfiguration korrekt dupliziert.',
      deleted: 'Produkt erfolgreich gelöscht',
      deleteError: 'Fehler beim Löschen des Produkts',
    },
    model: {
      loadError: 'Fehler beim Laden des Modells',
    },
    message: {
      creditsLow: {
        subject: 'Niedriges Credit-Guthaben',
        message:
          'Ihre Organisation hat noch {balance} Credits, nicht genug für eine weitere digitale Datei. Laden Sie auf, um weiter zu bestellen.',
      },
      creditsRequested: {
        subject: 'Credits angefordert',
        message:
          '{requesterName} hat {credits} zusätzliche Credits für Ihre Organisation angefordert.',
      },
      orderPlaced: {
        subject: 'Bestellung #{orderId} aufgegeben',
        message: 'Ihre Bestellung wurde erfolgreich aufgegeben.',
      },
      orderInProcess: {
        subject: 'Bestellung #{orderId} in Bearbeitung',
        message: 'Alle Artikel Ihrer Bestellung befinden sich derzeit in der Produktion.',
      },
      orderDelayed: {
        subject: 'Bestellung #{orderId} verzögert',
        message:
          'Bei Ihrer Bestellung ist ein Fehler aufgetreten. Wir werden uns bei Bedarf mit Ihnen in Verbindung setzen.',
      },
      orderShipped: {
        subject: 'Bestellung #{orderId} abgeschlossen',
        message:
          'Alle Artikel Ihrer Bestellung wurden versandt und werden in Kürze bei Ihnen eintreffen.',
      },
      orderInvoiced: {
        subject: 'Bestellung Nr. {orderId} in Rechnung gestellt',
        message: 'Ihre Bestellung mit der Nummer {orderId} wurde in Rechnung gestellt.',
      },
      productUpdated: {
        subject: 'Produkt-Update: {productName} - {productId}',
        message:
          'Das Produkt "{productName}" (ID: {productId}) wurde von unserem Support-Team aktualisiert.',
      },
      supportHasReactedToYourHelpRequest: {
        subject: '{productName} {productId} wurde vom Support aktualisiert',
        message: 'Wir haben auf Ihre Anfrage reagiert.',
      },
      announcement: {
        title: 'Neue Ankündigung',
        description:
          'Durch Klicken auf „Benachrichtigung senden“ wird eine Plattformbenachrichtigung an ALLE Benutzer gesendet.',
        confirmText: 'Benachrichtigung senden',
        success: 'Die Benachrichtigung wurde an alle Benutzer gesendet.',
        error: 'Beim Senden der Benachrichtigung an alle Benutzer ist ein Fehler aufgetreten.',
        form: {
          subject: {
            title: 'Betreff',
            placeholder: 'Bitte geben Sie einen Betreff ein....',
          },
          message: {
            title: 'Nachricht',
            placeholder: 'Bitte geben Sie Ihre Nachricht ein...',
          },
          link: {
            title: 'Link',
            placeholder:
              'Bitte gib einen Link ein, zu dem der Benutzer weitergeleitet werden soll...',
          },
        },
      },
      platformUpdates: {
        subject: 'Plattform-Updates',
        message: 'Wir haben einige Änderungen an der Plattform vorgenommen. ',
        title: 'Neues Plattform-Update',
      },
      newsletter: {
        subject: 'Newsletter',
        message:
          'Wir haben einige Updates für die Plattform. Bitte überprüfen Sie die Plattform für weitere Informationen.',
      },
    },
    userUpdated: 'Benutzer aktualisiert',
    errorUpdatingUser: 'Fehler beim Aktualisieren des Benutzers',
    notificationsCleared: 'Benachrichtigungen gelöscht',
    notificationSettingsUpdated: 'Benachrichtigungseinstellungen aktualisiert',
    patientDataUpdated: 'Patientendaten erfolgreich aktualisiert',
    patientDataUpdateFailed: 'Aktualisierung der Patientendaten fehlgeschlagen',
    fileDownloadedSuccessfully: '3D-Datei erfolgreich heruntergeladen',
    supportEditsAccepted: 'Support-Änderungen akzeptiert',
    supportEditsFailed: 'Support-Änderungen konnten nicht angewendet werden',
    changeRequestSubmitted: 'Änderungsanfrage erfolgreich eingereicht',
    changeRequestFailed: 'Änderungsanfrage konnte nicht eingereicht werden',
    mustBeLoggedIn: 'Sie müssen angemeldet sein, um Änderungen anzufordern',
    commentMinLength:
      'Bitte geben Sie einen Kommentar mit mindestens {minLength} Zeichen für Ihre Änderungsanfrage ein',
    delete: {
      title: 'Benachrichtigung löschen',
      message: 'Sind Sie sicher, dass Sie diese Benachrichtigung löschen möchten?',
      confirmText: 'Löschen',
      success: 'Benachrichtigung erfolgreich gelöscht',
    },
  },
  navigation: {
    back: 'Zurück',
    backToList: 'Zurück zur Liste',
    backToOverview: 'Zurück zur Übersicht',
    breadcrumbs: 'Brotkrümel-Navigation',
    currentPage: 'Aktuelle Seite',
    menu: {
      dashboard: 'Dashboard',
      patients: 'Patienten',
      products: 'Produkte',
      orders: 'Bestellungen',
      explore: 'Erkunden',
      support: 'Unterstützung',
      admin: 'Administration',
      manufacturing: 'Produktion',
      documentation: 'Dokumentation',
    },
  },
  editor: {
    save: 'Änderungen speichern',
    cancel: 'Abbrechen',
    discard: 'Änderungen verwerfen',
    confirmDiscard: 'Sind Sie sicher, dass Sie Ihre Änderungen verwerfen möchten?',
  },
  menu: {
    notifications: 'Benachrichtigungen',
    messages: 'Nachrichten',
    cart: 'Warenkorb',
    settings: 'Einstellungen',
    toggleMenu: 'Menü umschalten',
    closeMenu: 'Menü schließen',
    account: 'Konto',
    createNew: 'Neu',
    noNotifications: 'Keine Benachrichtigungen',
    noProducts: 'Es sind keine Produkte im Warenkorb',
    goToCheckout: 'Zur Kasse gehen',
    accountSettings: 'Kontoeinstellungen',
    logout: 'Abmelden',
    newProduct: 'Neues Produkt',
    newDistributorUser: 'Neuer Vertriebsmitarbeiter',
    newMasterUser: 'Neuer Hauptbenutzer',
    order: 'Bestellung anzeigen',
    reactionFromSupport: 'Änderungen anzeigen',
    announcement: 'Mehr erfahren',
    platformUpdates: 'Neuheiten entdecken',
    continue: 'Fortfahren',
  },
  details: {
    noLabel: 'Keine Bezeichnung',
    noValue: 'Kein Wert',
    viewDetails: 'Details anzeigen',
    moreInfo: 'Weitere Informationen',
  },
  cards: {
    viewItem: '{name} anzeigen',
    selectItem: '{name} auswählen',
    imageAlt: 'Bild von {name}',
    showInfo: 'Informationen anzeigen',
    hideInfo: 'Informationen verbergen',
    favourite: 'Produkt als Favorit markieren',
    companyFavourite: 'Produkt als Firmenfavorit markieren',
  },
  translation: {
    translate: 'Text übersetzen',
    translateTo: 'Übersetzen nach {language}',
    translating: 'Übersetzung läuft...',
    translationError: 'Fehler beim Übersetzen',
    defaultLanguage: 'Standardsprache',
  },
  brand: {
    name: 'OrthoSolid',
    logoAlt: 'OrthoSolid Logo',
  },
  fileUpload: {
    attachFile: 'Datei anhängen',
    dragAndDrop: 'Dateien hier ablegen',
    browse: 'Durchsuchen',
    maxSize: 'Maximale Dateigröße: {size}',
    invalidType: 'Ungültiger Dateityp',
    uploadError: 'Fehler beim Hochladen',
    loadError: 'Vorschau der 3D-Datei konnte nicht geladen werden',
    gltfExternalRefs:
      'GLTF-Dateien mit externen Referenzen werden nicht unterstützt. Bitte verwenden Sie stattdessen das GLB-Format.',
    uploadSuccess: 'Datei erfolgreich hochgeladen',
    remove: 'Datei entfernen',
    validating: 'Dateien werden validiert...',
    filesNotSupported:
      'Datei(en) nicht unterstützt: {rejectedNames}. Unterstützte Formate: {acceptedFormats}',
    filesSelected: '{count} von {max} Dateien ausgewählt',
    uploadInstructions:
      'Ihre Datei wird hochgeladen. Nach dem Hochladen können Sie den 3D-Scan mit unserem 3D-Cleaner-Tool im nächsten Schritt bereinigen und verbessern.',
    charactersMinimum: '{count}/{min} Zeichen Minimum',
    color: {
      label: 'Farbe',
      incoming: 'Keine Farbe (Dateifarbe verwenden)',
      presets: {
        white: 'Weiß',
        skin: 'Haut',
        blue: 'Blau',
        green: 'Grün',
        red: 'Rot',
        black: 'Schwarz',
      },
    },
  },
  supportTicket: {
    discussion: 'Diskussion',
    typeMessage: 'Nachricht eingeben...',
    send: 'Senden',
    attachFile: 'Datei anhängen',
    noComments: 'Keine Kommentare',
    addComment: 'Kommentar hinzufügen',
    uploadFile: 'Datei hochladen',
    close: 'Schließen',
    success: 'Support-Ticket erstellt.',
    error: 'Fehler beim Erstellen des Support-Tickets.',
    status: {
      received: 'Erhalten',
      under_investigation: 'In Untersuchung',
      on_hold: 'In Wartestellung',
      resolved: 'Gelöst',
    },
    productStatus: {
      dataInput: 'Dateneingabe',
      designing: 'Entwurf',
      readyToOrder: 'Bestellbereit',
      inCart: 'Im Warenkorb',
      helpRequested: 'Hilfe angefordert',
      updatedBySupport: 'Vom Support aktualisiert',
      ordered: 'Bestellt',
      demo: 'Demo',
      designRequested: 'Entwurf angefordert',
      orderedWithoutReview: 'Bestellt ohne Überprüfung',
      cancelled: 'Storniert',
    },
    orderStatus: {
      orderPlaced: 'Bestellung aufgegeben',
      processing: 'In Bearbeitung',
      shipped: 'Abgeschlossen',
      invoiced: 'Rechnung gestellt',
      delayed: 'Verzögert',
      ignore: 'Ignorieren',
      demo: 'Demo',
      designRequested: 'Design angefordert',
      orderedWithoutReview: 'Bestellt ohne Überprüfung',
      readyForReview: 'Bereit zur Überprüfung',
      generating3dFile: '3D-Datei wird generiert',
      threeDFileUnderReview: '3D-Datei wird überprüft',
      threeDFileAvailable: '3D-Datei verfügbar',
      downloaded: 'Heruntergeladen',
    },
    exportStatus: {
      notAvailable: 'N/V',
      generating: 'Wird generiert',
      failed: 'Fehlgeschlagen',
      missing: 'Fehlt',
      emptyFile: 'Leere Datei',
      valid: 'Gültig',
    },
    buttonText: 'Nachricht mit Link zum Modell senden',
  },
  workflow: {
    back: 'Zurück',
    next: 'Weiter',
    save: 'Speichern',
    exit: 'Beenden',
    continue: 'Fortfahren',
    cancel: 'Abbrechen',
    finish: 'Abschließen',
    instructions: 'Anweisungen',
    steps: {
      current: 'Aktueller Schritt',
      previous: 'Vorheriger Schritt',
      next: 'Nächster Schritt',
    },
    navigation: {
      back: 'Zurück',
      forward: 'Weiter',
      exit: 'Workflow verlassen',
    },
  },
  patientData: {
    scanOrientation: {
      label: 'Scan-Orientierung',
      placeholder: 'Scan-Orientierung auswählen',
      left: 'Linker',
      right: 'Rechter',
    },
    dataType: {
      label: 'Datentyp',
      file: 'Datei',
      measurement: 'Messung',
      form: 'Formular',
    },
    upload: {
      alignScan: 'Scan ausrichten',
      defineSide: 'Scan-Seite definieren',
      selectFile: 'Datei und Scan-Orientierung auswählen',
      uploadError: 'Fehler beim Hochladen der Datei',
      description: 'Datei und Scan-Orientierung auswählen',
      action: 'Datei hochladen',
    },
    createdOn: 'Erstellt am',
    notes: 'Notizen',
    actions: {
      editScan: 'Scan bearbeiten',
      editMeasurements: 'Messungen bearbeiten',
      editForm: 'Formular bearbeiten',
    },
    add: 'Patientendaten hinzufügen',
    notFinished: 'Nicht abgeschlossen',
    fields: {
      name: 'Name',
    },
    linkedProducts: 'Verknüpfte Produkte',
    newProduct: 'Neues Produkt',
    noLinkedProducts: 'Keine verknüpften Produkte gefunden',
    dataInput: 'Dateneingabe',
    selectDataInput: 'Wählen Sie eine Dateneingabe',
    createdBy: 'Erstellt von',
    editTitle: 'Patientendaten bearbeiten',
  },
  dataGrid: {
    bulkActions: {
      credits: {
        button: 'Credits / Product Workflows',
        title: 'Credits konfigurieren',
        error: {
          notAllowed: 'Nicht zulässig',
          maxSelected: 'Wählen Sie höchstens {maxSelected} Unternehmen aus',
          companyId: 'Das Unternehmen {companyId} konnte nicht gelesen werden',
          invalid: '',
        },
        appliesTo: 'Änderungen werden für folgende Unternehmen gespeichert',
        unchanged: 'Unverändert',
        saved: '{section} wurde für {count} Unternehmen gespeichert',
        partiallySaved:
          '{section} konnte für folgende Unternehmen nicht gespeichert werden: {companies}',
      },
      scheduleExports: 'Exporte planen',
      changeStatus: 'Status ändern',
      downloadProduction: 'Produktionsdateien herunterladen',
      downloadExports: 'Exporten herunterladen',
      downloadCsv: 'Bestelldaten herunterladen',
      addToCart: 'Zum Warenkorb hinzufügen',
      delete: 'Löschen',
      notifications: {
        statusSuccess: 'Status erfolgreich geändert',
        statusError: 'Fehler beim Ändern des Status',
        productionSuccess: 'Produktionsdateien erfolgreich heruntergeladen',
        productionError: 'Fehler beim Herunterladen der Produktionsdateien',
        exportSuccess: 'Exporten erfolgreich heruntergeladen',
        exportError: 'Fehler beim Herunterladen der Exporten',
        exportErrorExplanation: 'Es wurden keine herunterladbaren Produkte gefunden.',
        exportErrorNoProducts: 'No downloadable products found.',
        exportErrorIncomplete:
          '{failed} of {total} files could not be downloaded ({products}). Check your connection and try again — nothing was marked as downloaded.',
        cartSuccess: 'Produkte erfolgreich zum Warenkorb hinzugefügt',
        cartError: 'Fehler beim Hinzufügen der Produkte zum Warenkorb',
        deleteSuccess: 'Produkte erfolgreich gelöscht',
        deleteError: 'Fehler beim Löschen der Produkte',
        exportsSuccess: 'Exporte erfolgreich heruntergeladen',
        exportsError: 'Fehler beim Herunterladen der Exporte',
        exportsGenerating: 'Exporte werden generiert. Bitte versuchen Sie es in Kürze erneut.',
        orderInfoSuccess: 'Bestellinformationen erfolgreich heruntergeladen',
        orderInfoError: 'Fehler beim Herunterladen der Bestellinformationen',
      },
    },
    filter: {
      title: 'Filter',
      apply: 'Filter anwenden',
      cancel: 'Abbrechen',
    },
    showOnlyMyPatients: 'Nur meine Patienten anzeigen',
    showOnlyMyOrders: 'Nur meine Bestellungen anzeigen',
    showOnlyMyProducts: 'Nur meine Produkte anzeigen',
    search: 'Suchen...',
    manageColumns: 'Spalten verwalten',
  },
  help: {
    requestHelp: 'Hilfe anfordern',
    newTicket: 'Neues Ticket erstellen',
    openTicket: 'Ticket öffnen',
    viewTicket: 'Ticket anzeigen',
  },
  comments: {
    seeModel: 'Modell anzeigen',
    download: 'Herunterladen',
    author: 'Von {name}',
    createdAt: 'Erstellt am {date}',
    fileDetails: {
      name: 'Name',
      size: 'Größe',
      type: 'Typ',
    },
    selectedFile: 'Ausgewählte Datei',
    removeFile: 'Datei entfernen',
  },
  footer: {
    exploreMore: 'Mehr Produkte entdecken',
    back: 'Zurück',
    next: 'Weiter',
    exit: 'Speichern und Beenden',
    contact: 'Kontakt',
    location: 'Standort',
    copyright: '© {year} Orthobroker bv',
    followUs: 'Folgen Sie uns',
    newsletter: 'Newsletter',
    getUpdates: 'Erhalten Sie Updates zu unseren neuesten Produkten und Angeboten.',
    on: 'An',
    off: 'Aus',
    suscribed: 'Sie haben sich erfolgreich für unseren Newsletter angemeldet',
    unsubscribed: 'Sie haben sich erfolgreich von unserem Newsletter abgemeldet',
    stayUpToDate: 'Bleiben Sie auf dem Laufenden',
    form: {
      email: 'E-Mail-Adresse',
    },
  },
  visibility: {
    show: 'Sensible Daten anzeigen',
    hide: 'Sensible Daten verbergen',
  },
  dashboard: {
    startCreation: 'Erstellungsprozess starten',
    addNewPatient: 'Neuen Patienten hinzufügen',
    addPatientData: 'Patienten-Scan hinzufügen',
    continueDesigning: 'Weiter entwerfen',
    recentOrders: 'Aktuelle Bestellungen',
    viewAll: 'Alle anzeigen',
    columns: {
      productName: 'Produktname',
      patientName: 'Patientenname',
      status: 'Status',
      orderDate: 'Bestelldatum',
      orderId: 'Bestellnummer',
    },
  },
  redirect: {
    title: 'Weiterleitung erforderlich',
    description:
      'Sie müssen einige Schritte abschließen, bevor Sie auf diese Seite zugreifen können.',
    patient: 'Patientenauswahl',
    dataset: 'Datenauswahl',
    product: 'Produktauswahl',
    form: 'Formularauswahl',
    goTo: 'Gehe zu {destination}',
  },
  general: {
    back: 'Zurück',
    exit: 'Speichern & beenden',
    yes: 'Ja',
    no: 'Nein',
    on: 'An',
    off: 'Aus',
  },
  titles: {
    credits: 'Meine Credits',
    patient: 'Patient zuweisen',
    assignPatient: 'Patient zuweisen',
    createPatient: 'Neuer Patient',
    product: 'Produkt auswählen',
    dataset: 'Dataset auswählen',
    selectForm: 'Formular auswählen',
    editForm: 'Formular bearbeiten',
    newForm: 'Neues Formular',
    selectElimb: 'E-limb auswählen',
    elimb: 'E-limb messen',
    selectScan: 'Scan auswählen',
    alignScan: 'Ausrichten & bereinigen',
    admin: 'Administration',
    catalog: 'Katalog',
    checkout: 'Kasse',
    academy: 'Akademie',
    explore: 'Erkunden',
    orders: 'Bestellungen',
    tickets: 'Tickets',
    manufacturing: 'Produktion',
    dashboard: 'Dashboard',
    patientData: 'Patientendaten',
    products: 'Produkte',
    productWorkflowCategory: 'Kategorie auswählen',
  },
  product: {
    code: 'Produktcode',
    overview: {
      title: 'Produktübersicht',
    },
    next: 'Dataset auswählen',
    sections: {
      generalInfo: 'Allgemeine Produktinformationen',
      specifications: 'Produkt-Spezifikationen',
      details: 'Produktangaben',
    },
    fields: {
      status: 'Status',
      patient: 'Patient',
      type: 'Produkttyp',
      id: 'Produkt-ID',
      createdOn: 'Erstellt am',
      createdBy: 'Erstellt von',
      lastAdjustedOn: 'Zuletzt angepasst am',
      lastAdjustedBy: 'Zuletzt angepasst von',
      orderReference: 'Bestellreferenz',
      linkedScan: 'Verknüpfter Scan',
      copyFrom: 'Kopie von',
      edgePiping: {
        0: 'Aus',
        1: 'Überall',
        2: 'Nur Hand',
        3: 'Nur Daumen',
      },
      thumbWebFoldingEdge: {
        0: 'Aus',
        1: 'Niedrig',
        2: 'Medium',
        3: 'Hoch',
      },
      buckleType: {
        0: 'Keine Schnalle',
        1: 'FDM-Schleife',
      },
      dorsal: 'Dorsal',
      palmar: 'Palmar',
      transversalPalmArchIntensity: {
        0: 'Keine',
        1: 'Niedrig',
        2: 'Medium',
        3: 'Hoch',
      },
      productFinishing: {
        0: 'Nur gedruckte Schale',
        3: 'Orthese mit individueller Unterfütterung',
        1: 'Orthese mit individueller Auskleidung und separatem Gurtset',
        2: 'Orthese mit individueller Auskleidung und befestigten Gurten',
      },
    },
    properties: {
      title: 'Produkteigenschaften',
      edit: 'Eigenschaften bearbeiten',
      hinge_type: 'Art des Scharniers',
      brace_thickness: 'Verstrebungsdicke',
      material: 'Material',
      finishing: 'Oberflächenbehandlung',
      error: 'Fehler beim Bearbeiten der Eigenschaften',
    },
    actions: {
      delete: {
        title: 'Produkt löschen',
        message: 'Sind Sie sicher, dass Sie dieses Produkt löschen möchten?',
        confirmText: 'Löschen',
        error:
          'Das Produkt {id} kann nicht gelöscht werden, da es mit dem Support-Ticket {supportTicketId} verknüpft ist.',
      },
      addToCart: 'In den Warenkorb',
      removeFromCart: 'Aus dem Warenkorb entfernen',
      order: 'Zur Kasse gehen',
      showSpecifications: 'Spezifikationen anzeigen',
      showInfo: 'Produktinformation',
    },
    title: 'Produkt',
    new: 'Neues Produkt',
    empty: 'Keine Produkte gefunden',
    description: 'Produktbeschreibung',
    add: 'Produkt hinzufügen',
    workflow: {
      instructions: {
        start: `##### **Was möchten Sie tun?**
Wählen Sie die am besten geeignete Variante aus.
##### **Tipps:**
- Klicken Sie auf das Informationssymbol für eine kurze Beschreibung des Produkts`,
        overview: `##### **{title}**
Dies ist die Orthese, die Sie erstellen werden.
##### **Tipps:**
- Sie können dieses Design als Favorit speichern, indem Sie auf die Schaltfläche „Favorit“ klicken.`,
        flowStepTitle: '##### **{number}. {question}**',
        overviewTitle: '##### **{title}**',
        overviewHeading: 'Übersicht',
        flowStep: `##### **{number}. {question}**
Wählen Sie die Antwort, die am besten zu Ihrem Patienten passt.
##### **Tipps:**
- Sie können eine frühere Antwort ändern, indem Sie oben auf ihren Schritt klicken.`,
        noOutcome:
          'Zu diesen Antworten passt kein Produkt. Gehen Sie zurück und ändern Sie eine Antwort, oder bitten Sie einen Administrator, den Entscheidungsablauf zu vervollständigen.',
        noFlow:
          'Für diese Produktfamilie ist noch kein Entscheidungsablauf aktiv. Bitten Sie einen Administrator, ihn zu aktivieren.',
        noOptions: 'Für diesen Schritt ist mit den bisherigen Antworten keine Antwort verfügbar.',
        outcomeFailed:
          'Das Produkt zu diesen Antworten konnte nicht geladen werden. Prüfen Sie Ihre Verbindung und laden Sie die Seite neu.',
        outcomeNoWorkflow:
          'Dieses Produkt hat noch keinen Produkt-Workflow und kann daher nicht erstellt werden. Bitten Sie einen Administrator, ihn festzulegen.',
        error: 'Bei der Berechnung des Ergebnisses ist ein Fehler aufgetreten.',
      },
      thumbDiameter: {
        confirmText: 'Weiter',
        error: 'Bitte geben Sie einen gültigen Daumendurchmesser ein.',
      },
      extraPadding: {
        error: 'Bitte geben Sie an, ob Sie eine zusätzliche Polsterung wünschen oder nicht.',
        chip: {
          yes: 'Zusätzliche Polsterung',
          no: 'Keine zusätzliche Polsterung',
        },
      },
      favourite: {
        title: 'Favorit',
        success: 'Produkt als Favorit markiert.',
        error: 'Fehler beim Markieren der Carpi-Produktionskonfiguration als Favorit.',
      },
      unFavourite: {
        title: 'Aus Favoriten entfernen',
        message:
          'Möchten Sie diese {product}-Variante wirklich aus Ihrer Favoritenliste entfernen?',
        confirmText: 'Entfernen',
        success: 'Produkt als Favorit deaktiviert.',
        error: 'Fehler beim Deaktivieren des Produkts als Favorit.',
      },
      companyFavourite: {
        title: 'Unternehmensfavorit',
        success: 'Das Produkt wurde als Favorit für das Unternehmen markiert.',
        error: 'Fehler beim Markieren des Produkts als Favorit für das Unternehmen.',
      },
      companyUnfavourite: {
        title: 'Das Produkt als Favorit für das Unternehmen markieren.',
        message:
          'Möchten Sie diese {product}-Variante wirklich aus Ihrer Favoritenliste für das Unternehmen entfernen?',
        confirmText: 'Entfernen',
        success: 'Das Produkt wurde als Favorit für das Unternehmen markiert.',
        error: 'Fehler beim Entmarkieren des Produkts als Favorit für das Unternehmen.',
      },
      outcome: {
        title: 'Überblick',
      },
      duplicate: {
        baskoMultimotion: 'Basko Multimotion',
        caroliDyna: 'Caroli Dyna',
        caroliMono: 'Caroli Mono',
        albrecht: 'Albrecht',
        ultraFlex: 'UltraFlex',
      },
    },
  },
  productWorkflowCategory: {
    instructions: `##### **Welches Produkt braucht Ihr Patient?**
Wählen Sie eine Produktfamilie aus.
##### **Tipps:**
- Klicken Sie auf das Informationssymbol, um eine kurze Beschreibung der Produkte zu erhalten 
- Nachdem Sie die Produktfamilie ausgewählt haben, können Sie wählen, welche Variante Sie erstellen möchten`,
    next: 'Produkt auswählen',
  },
  patient: {
    info: 'Patienteninformation',
    instructions: `##### **Für wen erstellen Sie ein Produkt?**
Erstellen Sie einen neuen Patienten oder weisen Sie einen aus Ihrer Patientenliste zu.`,
    new: 'Neuer Patient',
    pick: 'Aus Patientenliste auswählen',
    exit: 'Schließen',
    next: 'Produktkategorie auswählen',
    create: 'Neuen Patienten hinzufügen',
    addPatient: 'Patient hinzufügen',
    close: 'Schließen',
    name: 'Patientenname',
  },
  dataset: {
    elimb: {
      instructions: `##### **Was sind die Maße des Arms des Patienten?**
Erstellen Sie einen neuen E-limb durch Messen Ihres Patienten oder wählen Sie einen aus dem Profil Ihres Patienten.
##### **Tipps:**
- Stellen Sie sicher, dass ein ausgewählter bestehender E-limb noch aktuell ist
- Beim Erstellen eines neuen E-limb, stellen Sie sicher, dass Sie folgende Werkzeuge griffbereit haben: Messschieber, Lineal`,
      create: 'Neuen E-limb erstellen',
      select: 'E-limb aus Patientenprofil auswählen',
      empty: 'Keine E-limbs gefunden',
      next: 'E-limb erstellen',
      save: 'Gelenkwinkel definieren',
    },
    scan: {
      instructions: `##### **Was sind die Maße des Arms des Patienten?**
Laden Sie einen neuen 3D-Scan hoch oder wählen Sie einen aus dem Profil Ihres Patienten.
##### **Tipps:**
- Stellen Sie sicher, dass ein ausgewählter bestehender 3D-Scan noch aktuell ist
- Wenn Sie einen neuen 3D-Scan hochladen, müssen Sie ihn ausrichten und bereinigen.
- Um den perfekten Scan für diese Software zu erstellen, siehe Scan-Handbuch`,
      upload: 'Neuen 3D-Scan hochladen',
      select: '3D-Scan aus Patientenprofil auswählen',
      empty: 'Keine 3D-Scans gefunden',
      next: 'Scan reinigen',
      save: 'Bereinigten Scan speichern',
      custom: {
        next: 'Produktbeschreibung',
      },
    },
    form: {
      assign: 'Formular zuweisen',
      empty: 'Keine Formulare verfügbar',
      instructions: '##### **Bitte wählen Sie ein Formular aus oder erstellen Sie ein neues**',
      select: 'Formular auswählen',
      new: 'Neues Formular erstellen',
      save: 'Formular speichern',
      next: 'Nächster Schritt',
      request: 'Produkt anfordern',
      altNext: 'Produkt bestellen',
      altButton: 'Formular aktualisieren',
      name: {
        title: 'Geben Sie Ihrem Formular einen Namen.',
        placeholder: 'Name eingeben',
      },
    },
    configure: 'Produkt-Creator',
  },
  list: {
    title: 'Produkte',
    empty: 'Keine Produkte gefunden',
    fields: {
      productId: 'Produkt-ID',
      productType: 'Produkttyp',
      createdOn: 'Erstellt am',
      status: 'Status',
    },
    actions: {
      new: 'Neu',
    },
  },
  model: {
    locked: 'Das Modell ist derzeit gesperrt, da es bestellt oder dem Warenkorb hinzugefügt wurde.',
  },
  mesh: {
    notFound: {
      title: 'Mesh nicht gefunden',
      message: 'Das Mesh wurde in der Szene nicht gefunden',
    },
    loaded: {
      title: 'Mesh geladen',
      message: 'Mesh erfolgreich geladen',
    },
    align: {
      title: 'Bitte Scan ausrichten',
      message:
        "Drücken Sie vor dem Speichern des Scans auf 'Align Scan'.\n(Speichern Sie erneut, um ohne Ausrichten fortzufahren) ",
    },
    clean: {
      title: 'Bitte Scan bereinigen',
      message:
        "Drücken Sie vor dem Speichern des Scans auf 'Clean Scan'.\n(Speichern Sie erneut, um ohne bereinigen fortzufahren) ",
    },
  },
  settings: {
    title: 'Einstellungen',
    sections: {
      company: 'Unternehmenseinstellungen',
      user: 'Benutzereinstellungen',
      general: 'Allgemeine Einstellungen',
    },
    fields: {
      useOwnPatientId: {
        label: 'Eigene Patienten-ID verwenden',
        description: 'Aktivieren Sie diese Option, um eigene Patienten-IDs zu definieren.',
      },
      sharePatients: {
        label: 'Patienten teilen',
        description: 'Aktivieren Sie diese Option, um Patienten mit anderen Benutzern zu teilen.',
      },
      useShippingInformation: {
        label: 'Versandinformationen verwenden',
        description: 'Aktivieren Sie diese Option, um Versandinformationen zu verwenden.',
      },
      anonymizedStartUp: {
        label: 'Anonymisierter Start',
        description: 'Aktivieren Sie diese Option für einen anonymisierten Start.',
      },
      assistedMode: {
        label: 'Assistierter Modus',
        description: 'Aktivieren Sie diese Option für den assistierten Modus.',
      },
      preferredLanguage: {
        label: 'Bevorzugte Sprache',
        description: 'Wählen Sie Ihre bevorzugte Sprache.',
      },
    },
    myAccount: 'Mein Konto',
    announcement: {
      button: 'Eine neue Ankündigung senden',
    },
    platformUpdate: {
      button: 'Ein Plattform-Update senden',
    },
    notificationSettings: 'Benachrichtigungseinstellungen',
    notifications: {
      inPlatform: 'In der Plattform',
      byEmail: 'Per E-Mail',
    },
  },
  scan: {
    title: '3D-Scan',
    fields: {
      id: 'Scan-ID',
      name: 'Scan-Name',
      orientation: 'Scan-Orientierung',
      lastAdjustedOn: 'Zuletzt angepasst am',
      lastAdjustedBy: 'Zuletzt angepasst von',
    },
  },
  elimb: {
    title: 'Elimb information',
    fields: {
      id: 'Elimb-ID',
      name: 'Elimb-Name',
      orientation: 'Scan-Orientierung',
      lastAdjustedOn: 'Zuletzt angepasst am',
      lastAdjustedBy: 'Zuletzt angepasst von',
    },
  },
  descriptions: {
    credits: 'Kaufen Sie Credits und sehen Sie, was Ihre Organisation noch drucken kann.',
    admin: 'Administration',
    catalog: 'Katalog',
    checkout: 'Kasse',
    academy: 'Akademie',
    explore: 'Erkunden',
    orders: 'Bestellungen',
    products: 'Produkte',
    tickets: 'Tickets',
  },
  distributor: {
    create: 'Distributor erstellen',
    add: 'Anwender hinzufügen',
  },
  cart: {
    empty: 'Warenkorb leer',
    delete: {
      title: 'Warenkorb löschen',
      message: 'Sind Sie sicher, dass Sie diesen Warenkorb löschen möchten?',
      confirmText: 'Löschen',
      success: 'Warenkorb erfolgreich gelöscht',
    },
  },
  checkout: {
    title: 'Kasse',
    contactInformation: {
      title: 'Kontaktinformation',
      description: 'Bitte geben Sie Ihre Kontaktinformationen ein',
    },
    products: {
      title: 'Produkte',
      description: 'Überprüfen Sie Ihre Produkte, bevor Sie zur Kasse gehen',
    },
  },
  academy: {
    title: 'Akademie',
  },
  manufacturing: {
    title: 'Fertigung',
    orders: {
      title: 'Fertigung - Bestellungen',
      tab: 'Reguläre Bestellungen',
    },
    designRequested: {
      title: 'Fertigung - Design angefordert',
    },
    ignoredItems: {
      title: 'Fertigung - Ignorierte Artikel',
      tab: 'Ignorierte Artikel',
    },
    creditOrders: {
      title: 'Fertigung - Credit-Anfragen',
      tab: 'Credit-Anfragen',
    },
    noItemsFound: 'Keine Fertigungsartikel gefunden',
    stlFiles: 'STL-Dateien',
    rows: {
      selectRow: 'Zeile auswählen',
      unselectRow: 'Zeile abwählen',
      selectAllRows: 'Zeile auswählen',
      unselectAllRows: 'Zeile abwählen',
    },
  },
  tickets: {
    fields: {
      product: 'Produkt',
      status: 'Status',
      createdBy: 'Erstellt von',
      id: 'ID',
      involving: 'Betrifft',
      description: 'Beschreibung',
      company: 'Unternehmen',
    },
  },
  products: {
    fields: {
      status: 'Status',
      name: 'Name',
      patientName: 'Patientenname',
      id: 'ID',
      notes: 'Notizen',
      producedBy: 'Produziert von',
    },
  },
  documentation: {
    title: 'Dokumentation',
    notAvailable: 'Derzeit ist keine Dokumentation verfügbar.',
    loading: 'Inhalte werden geladen...',
    selectDocument: 'Wählen Sie ein Dokument aus dem Inhaltsverzeichnis.',
  },
  explore: {
    title: 'Erkunden',
  },
  formFields: {
    togglePasswordVisibility: 'Passwort-Sichtbarkeit umschalten',
  },
  features: {
    currentlyDisabled: 'Diese Funktion ist derzeit deaktiviert',
  },
  components: {
    selectPatient: 'Patient auswählen',
    patientLabel: 'Patient',
    meshInspectorFrame: 'MeshInspector-Rahmen',
    doNotShowAgain: 'Dieses Popup nicht mehr anzeigen',
    submitText: 'Beginnen Sie mit dem Entwerfen',
    supportPreview: {
      title: 'Support-Vorschau',
      description:
        'Sie sehen eine Support-Vorschau. Akzeptieren Sie die Änderungen, um fortzufahren.',
      accept: 'Akzeptieren',
    },
    modelPreviews: {
      viewSelection: 'Modellansichtsauswahl',
      productView: 'Produktansicht',
      patientDataView: 'Patientendatenansicht',
      finalProduct: 'Endprodukt',
      threeDScan: '3D-Scan',
    },
    meshInspector: {
      saveWarnings: {
        title: 'Scan speichern',
        lead: 'Vor dem Speichern bitte beachten:',
        notCleanedBullet: "Das Mesh wurde nicht bereinigt. Nutze 'Clean Scan', um es zu heilen.",
        notAlignedBullet:
          "Der Scan ist nicht ausgerichtet. Nutze 'Align Scan', um ihn auszurichten.",
        proceed: 'Trotzdem speichern',
      },
    },
    customProducts: {
      noFormDataAvailable: 'Keine Formulardaten für dieses Produkt verfügbar.',
      changeRequestHistory: 'Änderungsanfrage-Verlauf',
      anonymous: 'Anonym',
      uploadModel: 'Modell hochladen',
      uploadModelTitle: 'Modell Hochladen',
      productFormData: 'Produktformulardaten',
      requestChangesButton: {
        title: 'Änderungen anfordern',
        description:
          'Diese Anfrage ändert den Produktstatus und benachrichtigt das OrthoSolid-Team. Unser Team wird Ihr Feedback prüfen und eine neue Version des Produkts gemäß Ihren Spezifikationen bereitstellen.',
      },
      buttons: {
        orderTitle: 'Akzeptieren und bestellen',
      },
      images: {
        title: 'Angehängte Bilder',
        description: 'Neue Bilder hochladen',
      },
      requestProduct: {
        dialog: {
          title: 'Individuelles Produkt anfordern',
          message: `Wenn Sie dieses Produkt anfordern, erstellen wir ein individuelles Design und stellen Ihnen anschließend eine Rechnung.\n\n**Wichtig:**\n\nBitte beachten Sie, dass die Erstellung des Designs bis zu drei Werktage dauern kann. Sie werden über die Plattformbenachrichtigungen und per E-Mail auf dem Laufenden gehalten.`,
          confirmText: 'Produkt anfordern',
        },
      },
      orderProduct: {
        dialog: {
          title: 'Produkt bestellen',
          message: `Wenn Sie dieses Produkt bestellen, erstellen und drucken wir ein individuelles Design ohne Ihre Überprüfung. Das Produkt wird versandt und in Rechnung gestellt.\n\n**Wichtig:**\n\nBitte beachten Sie, dass die Herstellung des Produkts bis zu 12 Werktage dauern kann. Sie werden über die Plattformbenachrichtigungen und per E-Mail auf dem Laufenden gehalten.`,
          confirmText: 'Produkt bestellen',
        },
      },
      updateForm: {
        dialog: {
          title: 'Formular aktualisieren',
          message:
            'Durch die Aktualisierung des Formulars wird dies auch auf andere Produkte angewendet, die dieses Formular verwenden.',
        },
      },
    },
  },
  youtubeEmbed: {
    player: 'YouTube-Player',
    allowedFeatures:
      'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture',
  },
  configurator: {
    calculating: 'Berechnung läuft...',
    error: {
      title: 'Fehler',
      description: 'Produkt nicht gefunden.',
      brace: {
        title: 'Eine Klammer muss berechnet werden, bevor Sie sie ausblenden können.',
      },
    },
    menu: {
      customTextLimit: 'Geben Sie bis zu 20 Zeichen ein. ({length} verwendet)',
      notes: {
        title: 'Informationen für die Produktion',
        productLabel: 'Den Namen des Patienten auf dem Produktetikett angeben',
        placeholder: 'Klicken Sie hier, um Notizen hinzuzufügen...',
      },
    },
  },
  volarShell: {
    error: {
      noAcces: 'Sie haben keinen Zugriff auf dieses Produkt.',
      noShell: 'Für dieses Produkt ist keine Shell-Datei verfügbar.',
      couldNotGenerate: 'Es konnte kein Download-Link für die Shell-Datei generiert werden.',
      failed: 'Das Abrufen der Shell-Datei ist fehlgeschlagen.',
    },
  },
  stlDownload: {
    buttonSingular: {
      title: '3D-Datei herunterladen',
    },
    buttonMultiple: {
      title: '3D-Dateien herunterladen',
    },
    buttonMultipleOrSingular: {
      title: '3D-Datei(en) herunterladen',
    },
    buttonGenerating: {
      title: '3D-Datei wird generiert',
    },
    buttonGeneratingMultiple: {
      title: '3D-Datei(en) werden generiert',
    },
    notification: {
      success: '3D-Dateien erfolgreich heruntergeladen!',
    },
  },
  demo: {
    form: {
      title: 'Orthosolid Demo',
      email: 'E-Mail-Adresse',
      name: 'Vollständiger Name',
      company: 'Unternehmen',
      carpi: 'Orthosolid Carpi Demo',
      mino: 'Orthosolid Mino Demo',
      volar: 'Orthosolid Volar Demo',
    },
    reset: 'Zurücksetzen',
    contactForm: {
      title: 'Kontaktformular',
      field: 'Text',
      placeholder: 'Geben Sie Ihre Nachricht an Orthobroker ein.',
    },
  },
  marketingWebsite: {
    contact: {
      form: {
        name: 'Name',
        company: 'Unternehmen',
        email: 'E-Mail',
        message: 'Nachricht',
        submit: 'Absenden',
        value: 'Wert',
        success:
          'Vielen Dank für Ihre Kontaktaufnahme mit OrthoSolid. Wir werden uns in Kürze bei Ihnen melden.',
        error:
          'Bei der Verarbeitung Ihrer Nachricht ist ein Fehler aufgetreten. Wir empfehlen Ihnen, uns direkt eine E-Mail an info@orthobroker.com zu senden.',
        recaptchaError: 'Bitte füllen Sie das reCAPTCHA aus.',
      },
    },
  },
  notificationTypes: {
    creditsLow: 'Niedriges Credit-Guthaben',
    creditsRequested: 'Credit-Anfragen',
    orderPlaced: 'Bestellung aufgegeben',
    orderInProcess: 'Bestellung in Bearbeitung',
    orderDelayed: 'Bestellung verzögert',
    orderShipped: 'Bestellung abgeschlossen',
    orderInvoiced: 'Bestellung fakturiert',
    reactionsFromSupport: 'Reaktionen vom Support',
    platformUpdates: 'Plattform-Updates',
    newsletter: 'Newsletter',
  },
  insights: {
    useCases: 'Anwendungsfälle',
    guides: 'Anleitungen',
    webinars: 'Webinare',
    comparisons: 'Vergleiche',
  },
  website: {
    menu: 'Menü',
  },
  addToCart: {
    errors: {
      noInput:
        'Es scheint, als wäre kein Produkt ausgewählt worden. Bitte versuchen Sie es erneut mit einem Produkt.',
      notReadyToOrder:
        'Dieses Produkt kann noch nicht bestellt werden. Bitte nehmen Sie vor der Bestellung die entsprechenden Anpassungen vor.',
      addingToCart:
        'Beim Hinzufügen des Produkts zum Warenkorb ist ein Fehler aufgetreten. Bitte wenden Sie sich an den Support.',
    },
  },
  credits: {
    checkout: {
      title: 'Credits',
      cost: 'Diese Bestellung kostet',
      balance: 'Ihr Guthaben',
      after: 'Guthaben nach dieser Bestellung',
      amount: '{credits} Credits',
      amountOne: '1 Credit',
      alreadyPaid: 'Bereits bezahlt',
      unknownCost: 'Preis unbekannt',
      shortfall: 'Ihnen fehlen {credits} Credits für diese Bestellung.',
      shortfallOne: 'Ihnen fehlt 1 Credit für diese Bestellung.',
      buy: 'Credits kaufen',
      requestMore: 'Mehr Credits anfordern',
      unpriced:
        'Für ein oder mehrere digitale Produkte in dieser Bestellung ist noch kein Credit-Preis hinterlegt. Bitte kontaktieren Sie Orthobroker vor der Bestellung.',
      covered: 'Ihr Guthaben deckt diese Bestellung.',
    },
    cart: {
      blocked:
        'Sie haben nicht genügend Credits für dieses Produkt. Ihnen fehlen {credits} Credits.',
      blockedOne: 'Sie haben nicht genügend Credits für dieses Produkt. Ihnen fehlt 1 Credit.',
      blockedUnpriced:
        'Für dieses Produkt ist noch kein Credit-Preis hinterlegt. Bitte kontaktieren Sie Orthobroker, bevor Sie es hinzufügen.',
    },
    request: {
      sent: 'Ihre Anfrage wurde an die Administratoren Ihrer Organisation gesendet.',
      sentShort: 'Anfrage gesendet',
      noAdmins:
        'Ihre Organisation hat keinen Administrator, an den diese Anfrage gesendet werden kann. Bitte kontaktieren Sie Orthobroker.',
      failed: 'Wir konnten Ihre Anfrage nicht senden. Bitte versuchen Sie es erneut.',
    },
    available: 'Verfügbare Credits',
    topUp: 'Aufladen',
    requestMore: 'Mehr Credits anfragen',
    requestMoreHint: 'Bitten Sie die Administration Ihres Unternehmens, Credits aufzuladen.',
    expiry: '{amount} Credits verfallen am {date}',
    expiryOne: '1 Credit verfällt am {date}',
    printsLeft: 'Noch {prints} Drucke',
    printsLeftOne: 'Noch 1 Druck',
    noPacks: 'Derzeit sind keine Credit-Pakete verfügbar.',
    loadError: 'Ihre Credits konnten nicht geladen werden. Bitte versuchen Sie es erneut.',
    currency: {
      label: 'Währung ändern:',
      note: 'Preise in anderen Währungen als EUR sind Richtwerte.',
    },
    orderStatus: {
      requested: 'Angefragt',
      confirmed: 'Bestätigt',
      cancelled: 'Storniert',
    },
    table: {
      distributor: 'Distributor',
      credits: 'Credits',
      price: 'Preis',
      pack: 'Paket',
      requestedBy: 'Angefragt von',
      requestedAt: 'Angefragt am',
      confirmedAt: 'Bestätigt am',
    },
    pack: {
      save: '{amount} sparen',
      prints: '{prints} Drucke',
      printsOne: '1 Druck',
      add: 'Hinzufügen',
      addHint:
        'Dieses Paket anfragen. Orthobroker stellt es in Rechnung und fügt die Credits hinzu.',
      expiry: 'Heute gekaufte Credits verfallen am {date}',
      requested: 'Angefragt',
      requestSuccessTitle: 'Anfrage gesendet',
      requestSuccess:
        'Wir haben Ihre Anfrage über {credits} Credits erhalten. Orthobroker stellt sie in Rechnung, und die Credits werden nach Zahlungsbestätigung gutgeschrieben.',
      requestNotAllowed:
        'Credits für Ihre Organisation muss Ihre Unternehmensadministration anfragen.',
      requestUnavailable: 'Dieses Paket ist derzeit für Ihr Unternehmen nicht verfügbar.',
      rateUnavailable: 'In Euro angezeigt: der {currency}-Kurs ist derzeit nicht verfügbar.',
      requestFailed: 'Ihre Anfrage konnte nicht gesendet werden. Bitte versuchen Sie es erneut.',
    },
    categories: {
      carpi: 'Carpi',
      mino: 'Mino',
      volar: 'Volar',
    },
    faq: {
      title: 'Über Credits',
      q1: 'Was sind Credits?',
      a1: 'Mit Credits kaufen Sie digitale Dateien, die Sie im eigenen Haus in 3D drucken können.',
      q2: 'Sind von Orthobroker gefertigte Produkte im Credit-System enthalten?',
      a2: 'Nein. Von Orthobroker gefertigte und gelieferte Produkte werden separat in Rechnung gestellt.',
      q3: 'Können Credits innerhalb meiner Organisation geteilt werden?',
      a3: 'Ja. Credits werden in Ihrer gesamten Organisation geteilt und können von allen Fachkräften genutzt werden.',
      q4: 'Verfallen Credits?',
      a4: 'Ja. Alle Credits verfallen {months} Monate nach dem Kaufdatum.',
      q5: 'Wie viele Credits kostet eine digitale Datei?',
      a5: 'Die Anzahl der benötigten Credits hängt vom jeweiligen Produkt ab und wird vor dem Kauf angezeigt.',
    },
  },
  decisionFlows: {
    title: 'Produkt-Entscheidungsabläufe',
    description:
      'Erstellen Sie ohne Code den Fragebogen, der ein Produkt und seine Startparameter auswählt.',
    loading: 'Abläufe werden geladen',
    saving: 'Wird gespeichert…',
    flow: 'Ablauf',
    untitled: 'Ohne Titel',
    reorder:
      '{name} verschieben: ziehen, die Pfeiltasten verwenden oder öffnen, um es nach oben oder unten zu verschieben',
    moveUp: 'Nach oben',
    moveDown: 'Nach unten',
    tabs: {
      questions: 'Fragen',
      outcomes: 'Endergebnisse',
      credits: 'Credit-System',
      simulator: 'Ausprobieren',
    },
    credits: {
      intro:
        'Legen Sie fest, wann ein mit diesem Ablauf erstelltes Produkt Credits vom Kundenkonto verbraucht. Die Regel wird bei der Bestellung des Produkts geprüft.',
      match: 'Credits verbrauchen, wenn',
      matches: {
        all: 'Alle Bedingungen zutreffen (UND)',
        any: 'Eine Bedingung zutrifft (ODER)',
      },
      legend: 'Bedingungen',
      noQuestions:
        'Keine Frage speichert ihre Antwort in der Produktkonfiguration, daher kann keine über Credits entscheiden.',
      unpriced:
        'Diese Kategorie hat keinen Credit-Preis, daher lehnt der Checkout jedes Produkt ab, das die Regel auswählt.',
      fallback:
        'Keine Bedingungen: Es gilt die integrierte Regel, und nur Produkte, die der Kunde selbst produziert, verbrauchen Credits.',
    },
    toolbar: {
      importJson: 'JSON importieren',
      exportJson: 'JSON exportieren',
      imported: '{title} importiert',
      exported: '{file} exportiert',
      fileTooLarge: 'Die Datei ist größer als {size}.',
      hideList: 'Liste ausblenden',
      showList: 'Liste einblenden',
    },
    flows: {
      none: 'Es gibt noch keine Abläufe. Erstellen Sie den ersten, um zu beginnen.',
      create: 'Neuer Ablauf',
      createTitle: 'Neuer Ablauf',
      settingsTitle: 'Einstellungen des Ablaufs',
      name: 'Name des Ablaufs',
      category: 'Produktkategorie',
      categoryHint: 'Legt fest, aus welchen Produkten dieser Ablauf wählen kann.',
      noCategory: 'Keine Kategorie',
      saveSettings: 'Einstellungen speichern',
      duplicateTitle: 'Ablauf duplizieren',
      duplicate: 'Kopie erstellen',
      copyName: '{title} (Kopie)',
      live: 'Bei der Produkterstellung verwenden',
      liveHint:
        'Die Produkterstellung in dieser Kategorie folgt diesem Ablauf. Beim Einschalten wird jeder andere Ablauf der Kategorie ausgeschaltet.',
      liveNeedsCategory:
        'Wählen Sie zuerst eine Produktkategorie: Der Ablauf führt durch die Produkterstellung dieser Kategorie.',
      liveWithIssues:
        'Dieser Ablauf hat {count} Probleme. Die Produkterstellung hält dort an, wo sie eine Lücke lassen.',
      liveTag: 'in der Produkterstellung',
      cancel: 'Abbrechen',
      delete: 'Ablauf löschen',
      more: 'Weitere Aktionen zum Ablauf',
    },
    deleteFlow: {
      title: 'Diesen Ablauf löschen?',
      body: '{title} wird mit seinen Fragen und Endergebnissen gelöscht. Das lässt sich nicht rückgängig machen.',
      confirm: 'Ablauf löschen',
    },
    confirmDelete: {
      confirm: 'Löschen',
      cancel: 'Abbrechen',
      title: '{name} löschen?',
      conditionTitle: 'Die Bedingung auf {question} löschen?',
      combinationTitle: 'Kombination {number} löschen?',
      question:
        'Ihre Antworten werden mitgelöscht, und Bedingungen und Kombinationen, die sie lesen, vergessen sie. Das kann nicht rückgängig gemacht werden.',
      answer:
        'Bedingungen und Kombinationen, die diese Antwort wählen, vergessen sie. Das kann nicht rückgängig gemacht werden.',
      condition:
        'Ohne sie hängt dies nicht mehr von dieser Frage ab. Das kann nicht rückgängig gemacht werden.',
      parameter: 'Dieser Wert wird nicht mehr gesetzt. Das kann nicht rückgängig gemacht werden.',
      dialog:
        'Der Dialog und seine Auswahlmöglichkeiten werden entfernt. Das kann nicht rückgängig gemacht werden.',
      choice:
        'Die Auswahl und ihre Parameter werden entfernt. Das kann nicht rückgängig gemacht werden.',
      combination:
        'Diese Antworten wählen ihr Produkt nicht mehr. Die Produktkonfiguration selbst bleibt erhalten. Das kann nicht rückgängig gemacht werden.',
    },
    stepTypes: {
      decisionQuestion: 'Frage',
    },
    fields: {
      target: 'Gilt für',
      targets: {
        shapediver: '3D-Modell',
        product: 'Produkt',
      },
      numberRequired: 'Geben Sie eine Zahl ein',
      translate: 'Aus dem Englischen übersetzen',
      translations: 'Übersetzungen ({filled}/{total})',
      translateFailed: 'Es wurde nichts übersetzt. Versuchen Sie es gleich noch einmal.',
      linked: 'Mit dem Produktassistenten geteilt: eine Änderung hier erscheint auch dort',
      linkedNameKept:
        'Ein Name ist erforderlich – der gespeicherte bleibt, bis du einen neuen eingibst',
      translated: 'In {count} Sprachen übersetzt',
      markdown: {
        bold: 'Fett',
        italic: 'Kursiv',
        heading: 'Überschrift',
        bulletList: 'Aufzählung',
        orderedList: 'Nummerierte Liste',
      },
      pick: 'Feld auswählen…',
      unknown: '{name} (kein Parameter des 3D-Modells)',
      unknownError:
        '{name} ist kein Parameter der 3D-Modelle der {category}-Produkte, die dieser Ablauf erstellen kann. Wählen Sie einen aus der Liste.',
      modelHint:
        'Aus den 3D-Modellen der {category}-Produkte, die dieser Ablauf erstellen kann. Ein Name, den nicht jedes Produkt hat, nennt die Produkte, die ihn haben.',
      modelEmpty:
        'Die Produkte von {category} haben noch keine synchronisierte ShapeDiver-Sitzung, daher gibt es keine Parameter zur Auswahl.',
      misspelled: 'In anderen Modellen anders geschrieben',
      spellingWarning:
        'Andere 3D-Modelle schreiben diesen Parameter {spellings}. Ein Wert erreicht nur die Modelle, die ihn genau so schreiben: Benennen Sie den Parameter in ShapeDiver um, damit alle Modelle übereinstimmen.',
      noCategory:
        'Weisen Sie diesem Ablauf zuerst eine Kategorie zu: Die 3D-Modelle ihrer Produkte stehen hier zur Auswahl.',
    },
    questions: {
      empty: 'Dieser Ablauf hat noch keine Fragen. Fügen Sie unten die erste hinzu.',
      count: 'Fragen: {count}',
      addQuestion: 'Frage hinzufügen',
      questionTitle: 'Frage',
      instructionsTitle: 'Titel der grünen Karte',
      instructionsTitleHint:
        'Überschrift der grünen Karte im Produktassistenten. Bleibt das Feld leer, erscheint die Frage.',
      instructions: 'Text der grünen Karte',
      instructionsHint: 'Markdown, das im Produktassistenten unter der Frage erscheint',
      answerField: 'Konfigurator-Parameter',
      answerFieldHint:
        'Jede Antwort gibt diesem Parameter des 3D-Modells seinen Wert. Leer gelassen, stellt die Frage im Konfigurator nichts ein.',
      disabled: 'Deaktiviert',
      disabledDescription:
        'Wird im Dialog angewendet, um ein Produkt in eine andere Konfiguration zu duplizieren',
      companyHidable: 'Pro Unternehmen ausblendbar',
      companyHidableDescription:
        'Erscheint auf dem Tab Produkt-Workflows eines Unternehmens, wo die Antworten für dieses Unternehmen ausgeblendet werden können',
      decidedValue: 'Wert von {field}',
      setDecidedValue: '{field} festlegen',
      clearDecidedValue: 'Wert von {field} löschen',
      answerCount: '{count} Antworten',
      options: 'Antworten',
      optionLabel: 'Antwort',
      addOption: 'Antwort hinzufügen',
      olderParameters:
        'Setzt außerdem {values}, aus der Zeit, als Antworten noch eine eigene Parameterliste hatten.',
      removeOlderParameters: 'Entfernen',
      removeOption: 'Antwort {name} entfernen',
      deleteStep: '{name} löschen',
      parameterName: 'Speichert in',
      min: 'Minimum',
      max: 'Maximum',
      step: 'Schrittweite',
      unit: 'Einheit',
      defaultValue: 'Standardwert',
    },
    conditions: {
      stepLegend: 'Nur fragen, wenn',
      optionLegend: 'Nur anzeigen, wenn',
      question: 'Frage',
      answers: 'Antworten',
      add: 'Bedingung hinzufügen',
      remove: 'Bedingung zu {question} entfernen',
      pickAnswers: 'Wählen Sie mindestens eine Antwort',
    },
    dialogs: {
      add: 'Dialog hinzufügen',
      count: 'Dialoge',
      dialogTitle: 'Titel des Dialogs',
      description: 'Beschreibung',
      control: 'Bedienelement',
      controls: {
        single: 'Eine Auswahl',
        multi: 'Mehrere Auswahlen',
        number: 'Zahl',
        text: 'Text',
      },
      optional: 'Optional',
      showOnOutcome: 'Auf der Endergebniskarte anzeigen',
      choiceLabel: 'Auswahl',
      addChoice: 'Auswahl hinzufügen',
      skip: 'Überspringen',
      removeChoice: 'Auswahl {name} entfernen',
      remove: 'Dialog {name} entfernen',
      value: 'Wert',
    },
    outcomes: {
      addRow: 'Kombination hinzufügen',
      overviewTitle: 'Titel der Übersicht',
      overviewTitleHint:
        'Überschrift der grünen Karte des letzten Assistentenschritts. Bleibt das Feld leer, erscheint Übersicht.',
      overview: 'Text der Übersicht',
      overviewHint:
        'Markdown auf der grünen Karte des letzten Assistentenschritts, Übersicht. Bleibt das Feld leer, erscheint der Standardtext.',
      addMissing: 'Fehlende Kombinationen hinzufügen',
      missingTitle: 'Fehlende Kombinationen: {count}',
      addMissingRow: 'Kombination hinzufügen',
      addMissingRowFor: 'Kombination hinzufügen für {answers}',
      missingMore:
        '{count} weitere sind nicht aufgeführt. „Fehlende Kombinationen hinzufügen“ fügt alle hinzu.',
      anyAnswer: 'Beliebige Antworten',
      rowCount: 'Kombinationen: {count}',
      hint: 'Wähle jede Antwort, die eine Kombination abdeckt. Antworten, die ihre anderen Felder ausschließen, sind ausgegraut, und eine Frage, die sie nie stellt, bleibt leer.',
      table: 'Tabelle der Endergebnisse',
      actions: 'Aktionen',
      any: 'Beliebig',
      choose: 'Auswählen…',
      notAsked: 'Nicht gefragt',
      name: 'Name',
      image: 'Bild',
      answerCell: '{question}, Kombination {number}',
      openDetails: 'Details zu Kombination {number}',
      deleteRow: 'Kombination {number} löschen',
      details: 'Kombination {number}',
      productTemplate: 'Produkt-Workflow',
      productHint:
        'Beim Speichern der Kombination entsteht eine eigene Produktkonfiguration mit Name, Workflow, Bild und Antworten.',
      linkedHint:
        'Änderungen werden beim Speichern der Kombination übernommen. Ein Produkt, das ein anderer Ablauf oder eine andere Kategorie verwendet, erhält eine eigene Kopie.',
      discard: 'Verwerfen',
      saveRow: 'Kombination {number} speichern',
      saved: 'Kombination {number} gespeichert',
      close: 'Schließen',
      product: 'Produkt',
      imageUpload: 'Bild hochladen',
      imageReplace: 'Bild ersetzen',
      imageUploading: 'Wird hochgeladen…',
      imagePending: 'Wird mit der Kombination gespeichert',
      imageNeedsSave:
        'Zuerst die Kombination speichern: Das Bild gehört zu dem Produkt, das sie anlegt.',
      imageFailed: 'Das Bild konnte nicht hochgeladen werden. Bitte erneut versuchen.',
      imageBrowse: 'Bild in der Galerie ansehen',
    },
    parameters: {
      title: 'Parameter',
      name: 'Feld',
      remove: 'Parameter {name} entfernen',
      valueType: 'Werttyp',
      reservedName: 'Dieser Name ist reserviert, bitte einen anderen wählen.',
      valueTypes: {
        decisionParameterNumber: 'Zahl',
        decisionParameterBoolean: 'Ja / Nein',
        decisionParameterString: 'Text',
      },
      value: 'Wert',
      add: 'Parameter hinzufügen',
      help: 'Werte, die gesetzt werden, sobald es gilt, jeweils für einen Parameter des 3D-Modells oder ein Produktfeld. Ziel und Typ des Werts richten sich nach dem Feld.',
      pickOption: 'Option wählen…',
      unsynced:
        'Synchronisieren Sie die ShapeDiver-Sitzung dieses Parameters, um aus seinen Optionen zu wählen.',
      true: 'Wahr',
      false: 'Falsch',
    },
    simulator: {
      title: 'Fragebogen ausprobieren',
      restart: 'Neu beginnen',
      change: 'Ändern',
      changeAnswer: 'Ändern: Antwort auf {question}',
      valueHint: 'Zwischen {min} und {max}',
      outOfRange: 'Geben Sie einen Wert zwischen {min} und {max} ein',
      result: 'Ausgewähltes Produkt',
      shapediverParameters: 'Einstellungen des 3D-Modells',
      productParameters: 'Produktparameter',
      noParameters: 'Keine',
      invalid: 'Der Fragebogen kann nicht fortgesetzt werden:',
    },
    issues: {
      none: 'Keine Probleme gefunden',
      count: 'Probleme: {count}',
      emptyQuestion: 'Diese Frage hat keine Antworten.',
      emptyFlow: 'Der Ablauf hat keine Schritte.',
      unknownCondition: 'Eine Bedingung liest eine Frage, die es im Ablauf nicht gibt.',
      forwardCondition: 'Eine Bedingung liest eine Frage, die erst später gestellt wird.',
      resultWithoutProduct: 'Diese Kombination hat kein Produkt.',
      unknownAnswer:
        'Eine Bedingung oder Kombination verweist auf eine Antwort, die es nicht mehr gibt.',
      unreachableResult:
        'Eine spezifischere Kombination gewinnt immer gegen diese, daher wird sie nie verwendet.',
      conflictingResults: 'Eine andere Kombination ist für dieselben Antworten genauso spezifisch.',
      impossibleResult:
        'Diese Antworten können nie zusammen gegeben werden, daher wird diese Kombination nie verwendet.',
      unansweredCell:
        'Wähle für jede Frage, die diese Kombination stellt, die Antworten, die sie abdeckt.',
      impossibleAnswer:
        'Eine hier gewählte Antwort kann nie zusammen mit den anderen Antworten dieser Kombination vorkommen.',
      duplicateResult: 'Eine andere Kombination hat genau dieselben Antworten.',
      missingResult: 'Manche Antwortkombinationen führen zu keinem Produkt.',
      tooManyCombinations:
        'Dieser Ablauf hat zu viele Antwortkombinationen, um vollständig geprüft zu werden.',
      emptyDialog: 'Dieser Dialog fragt nichts ab: Er hat keine Auswahl und keinen Parameter.',
      invalidDialogBounds:
        'Das Minimum liegt über dem Maximum oder die Schrittweite ist nicht größer als null.',
      undeclaredAnswerField:
        'Diese Frage setzt einen Konfigurator-Parameter, den die 3D-Modelle, die dieser Ablauf erstellen kann, nicht haben.',
      unknownProductField:
        'Diese Antwort setzt einen Produktwert, der kein Produktfeld ist, daher verwerfen neue Produkte ihn. Senden Sie ihn stattdessen an das 3D-Modell.',
      invalidCreditCondition:
        'Eine Credit-Bedingung hat keine Antworten oder liest eine Frage, deren Antwort nicht am Produkt gespeichert wird, daher ignorieren Bestellungen sie.',
    },
    parseErrors: {
      invalidJson: 'Die Datei ist kein gültiges JSON.',
      notAFlow: 'Die Datei ist kein Produkt-Entscheidungsablauf.',
      invalidStep: 'Ein Schritt ist ungültig ({path}).',
      invalidOption: 'Eine Antwort ist ungültig ({path}).',
      invalidParameter: 'Ein Parameter ist ungültig ({path}).',
      invalidResult: 'Eine Kombination ist nicht gültig ({path}).',
      invalidCondition: 'Eine Bedingung ist ungültig ({path}).',
      invalidDialog: 'Ein Dialog ist ungültig ({path}).',
      invalidAnswerField: 'Ein Fragefeld ist ungültig ({path}).',
      duplicateKey: 'Zwei Elemente haben denselben Schlüssel ({path}).',
      unknownField: 'Die Datei enthält ein Feld, das das Ablaufformat nicht kennt ({path}).',
      tooLarge: 'Der Ablauf hat zu viele Elemente, um ihn zu öffnen ({path}).',
    },
    storage: {
      'not-allowed':
        'Sanity hat diese Aktion abgelehnt. Prüfen Sie, ob Sie angemeldet sind und Ihre Rolle sie erlaubt.',
      otherDataset: 'Entscheidungsabläufe werden nur im Arbeitsbereich {dataset} bearbeitet.',
      openDataset: 'Editor für {dataset} öffnen',
      linkedFailed:
        'Ein gemeinsamer Text konnte nicht gespeichert werden. Laden Sie diesen Tab neu, um die gespeicherte Fassung zu sehen.',
      'not-found': 'Diesen Ablauf gibt es nicht mehr.',
      dropped: 'Nicht lesbare Abläufe wurden ausgelassen: {count}.',
      invalid: 'Die Änderungen konnten nicht gespeichert werden, da der Ablauf ungültig ist.',
      failed: 'Die Änderungen konnten nicht gespeichert werden. Bitte erneut versuchen.',
    },
  },
};

export default de;
